/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API'

type GeneratedQuery<InputType, OutputType> = string & {
	__generatedQueryInput: InputType
	__generatedQueryOutput: OutputType
}

export const getProjectTotals =
	/* GraphQL */ `query GetProjectTotals($projectId: String!) {
  getProjectTotals(projectId: $projectId) {
    id
    name
    quotes {
      id
      name
      sectionTotals {
        isInternational
        sectionPrefix
        sectionRoman
        sectionId
        sectionUuid
        sectionName
        sectionName_fr
        budgetTotal
        provisionalTotal
        actualTotal
        purchaseTotal
        budgetWithMarginTotal
        attribute
      }
      localSectionTotals {
        isInternational
        sectionPrefix
        sectionRoman
        sectionId
        sectionUuid
        sectionName
        sectionName_fr
        budgetTotal
        provisionalTotal
        actualTotal
        purchaseTotal
        budgetWithMarginTotal
        attribute
      }
      internationalSectionTotals {
        isInternational
        sectionPrefix
        sectionRoman
        sectionId
        sectionUuid
        sectionName
        sectionName_fr
        budgetTotal
        provisionalTotal
        actualTotal
        purchaseTotal
        budgetWithMarginTotal
        attribute
      }
      totals {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      localTotals {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      internationalTotals {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      discount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
    }
    sectionTotals {
      isInternational
      sectionPrefix
      sectionRoman
      sectionId
      sectionUuid
      sectionName
      sectionName_fr
      budgetTotal
      provisionalTotal
      actualTotal
      purchaseTotal
      budgetWithMarginTotal
      attribute
    }
    totals {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
    }
    localTotals {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
    }
    internationalTotals {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
    }
    discount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    localSectionTotals {
      isInternational
      sectionPrefix
      sectionRoman
      sectionId
      sectionUuid
      sectionName
      sectionName_fr
      budgetTotal
      provisionalTotal
      actualTotal
      purchaseTotal
      budgetWithMarginTotal
      attribute
    }
    internationalSectionTotals {
      isInternational
      sectionPrefix
      sectionRoman
      sectionId
      sectionUuid
      sectionName
      sectionName_fr
      budgetTotal
      provisionalTotal
      actualTotal
      purchaseTotal
      budgetWithMarginTotal
      attribute
    }
    reportBlockReason
    projectTypeAutoCorrected
    originalProjectType
    resolvedProjectType
    effectiveStarredQuoteTypes
  }
}
` as GeneratedQuery<
		APITypes.GetProjectTotalsQueryVariables,
		APITypes.GetProjectTotalsQuery
	>
export const getAuditEvent =
	/* GraphQL */ `query GetAuditEvent($tenantId: ID!, $sk: String!) {
  getAuditEvent(tenantId: $tenantId, sk: $sk) {
    tenantId
    sk
    id
    ts
    action
    outcome
    reason
    actor {
      type
      id
      email
    }
    source {
      type
      ip
      userAgent
      sessionId
    }
    entity {
      type
      id
      externalId
      provider
    }
    entityKey
    before
    after
    metadata
    correlationId
    requestId
    idempotencyKey
    env
    hash
    prevHash
    ttl
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
		APITypes.GetAuditEventQueryVariables,
		APITypes.GetAuditEventQuery
	>
export const listAuditEvents = /* GraphQL */ `query ListAuditEvents(
  $tenantId: ID
  $sk: ModelStringKeyConditionInput
  $filter: ModelAuditEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAuditEvents(
    tenantId: $tenantId
    sk: $sk
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tenantId
      sk
      id
      ts
      action
      outcome
      reason
      actor {
        type
        id
        email
      }
      source {
        type
        ip
        userAgent
        sessionId
      }
      entity {
        type
        id
        externalId
        provider
      }
      entityKey
      before
      after
      metadata
      correlationId
      requestId
      idempotencyKey
      env
      hash
      prevHash
      ttl
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListAuditEventsQueryVariables,
	APITypes.ListAuditEventsQuery
>
export const eventsByTenant = /* GraphQL */ `query EventsByTenant(
  $tenantId: ID!
  $ts: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAuditEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByTenant(
    tenantId: $tenantId
    ts: $ts
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      tenantId
      sk
      id
      ts
      action
      outcome
      reason
      actor {
        type
        id
        email
      }
      source {
        type
        ip
        userAgent
        sessionId
      }
      entity {
        type
        id
        externalId
        provider
      }
      entityKey
      before
      after
      metadata
      correlationId
      requestId
      idempotencyKey
      env
      hash
      prevHash
      ttl
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.EventsByTenantQueryVariables,
	APITypes.EventsByTenantQuery
>
export const eventsByAction = /* GraphQL */ `query EventsByAction(
  $action: String!
  $ts: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAuditEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByAction(
    action: $action
    ts: $ts
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      tenantId
      sk
      id
      ts
      action
      outcome
      reason
      actor {
        type
        id
        email
      }
      source {
        type
        ip
        userAgent
        sessionId
      }
      entity {
        type
        id
        externalId
        provider
      }
      entityKey
      before
      after
      metadata
      correlationId
      requestId
      idempotencyKey
      env
      hash
      prevHash
      ttl
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.EventsByActionQueryVariables,
	APITypes.EventsByActionQuery
>
export const eventsByEntity = /* GraphQL */ `query EventsByEntity(
  $entityKey: String!
  $ts: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAuditEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventsByEntity(
    entityKey: $entityKey
    ts: $ts
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      tenantId
      sk
      id
      ts
      action
      outcome
      reason
      actor {
        type
        id
        email
      }
      source {
        type
        ip
        userAgent
        sessionId
      }
      entity {
        type
        id
        externalId
        provider
      }
      entityKey
      before
      after
      metadata
      correlationId
      requestId
      idempotencyKey
      env
      hash
      prevHash
      ttl
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.EventsByEntityQueryVariables,
	APITypes.EventsByEntityQuery
>
export const getBankAccountInfo =
	/* GraphQL */ `query GetBankAccountInfo($id: ID!) {
  getBankAccountInfo(id: $id) {
    id
    tenantId
    activeFlag
    isSelected
    name
    balance
    status
    status_code_info
    status_code_description
    updated_at
    type
    currency_code
    item_id
    bank_id
    loan_details {
      next_payment_date
      next_payment_amount
      maturity_date
      opening_date
      interest_rate
      type
      borrowed_capital
      repaid_capital
      remaining_capital
    }
    savings_details {
      opening_date
      interest_rate
      ceiling
    }
    is_pro
    iban
    balanceHistory {
      balance
      updated_at
    }
    lastUpdatedTransactionDate
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedQuery<
		APITypes.GetBankAccountInfoQueryVariables,
		APITypes.GetBankAccountInfoQuery
	>
export const listBankAccountInfos = /* GraphQL */ `query ListBankAccountInfos(
  $filter: ModelBankAccountInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listBankAccountInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      isSelected
      name
      balance
      status
      status_code_info
      status_code_description
      updated_at
      type
      currency_code
      item_id
      bank_id
      loan_details {
        next_payment_date
        next_payment_amount
        maturity_date
        opening_date
        interest_rate
        type
        borrowed_capital
        repaid_capital
        remaining_capital
      }
      savings_details {
        opening_date
        interest_rate
        ceiling
      }
      is_pro
      iban
      balanceHistory {
        balance
        updated_at
      }
      lastUpdatedTransactionDate
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListBankAccountInfosQueryVariables,
	APITypes.ListBankAccountInfosQuery
>
export const bankAccountInfoByTenantId =
	/* GraphQL */ `query BankAccountInfoByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelBankAccountInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  bankAccountInfoByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      isSelected
      name
      balance
      status
      status_code_info
      status_code_description
      updated_at
      type
      currency_code
      item_id
      bank_id
      loan_details {
        next_payment_date
        next_payment_amount
        maturity_date
        opening_date
        interest_rate
        type
        borrowed_capital
        repaid_capital
        remaining_capital
      }
      savings_details {
        opening_date
        interest_rate
        ceiling
      }
      is_pro
      iban
      balanceHistory {
        balance
        updated_at
      }
      lastUpdatedTransactionDate
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.BankAccountInfoByTenantIdQueryVariables,
		APITypes.BankAccountInfoByTenantIdQuery
	>
export const getBankTransactions =
	/* GraphQL */ `query GetBankTransactions($id: ID!) {
  getBankTransactions(id: $id) {
    id
    tenantId
    activeFlag
    flag
    clean_description
    bank_description
    amount
    date
    updated_at
    currency_code
    is_deleted
    category_id
    account_id
    account_name
    is_future
    show_client_side
    projectId
    projectName
    status
    tags
    transactionType
    uniqueTransactionId
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    preparePurchase {
      items {
        id
        tenantId
        activeFlag
        uniqueTransactionId
        flag
        invoiceName
        ocrInvoiceName
        fileName
        ocrFileName
        invoiceDate
        ocrInvoiceDate
        paymentDate
        ocrPaymentDate
        paymentStatus
        preparePurchasePaidDate
        supplier
        ocrSupplier
        po
        ocrPO
        costlineName
        costlineName_fr
        projectName
        totalAmount
        taxAmount
        netAmountDetails {
          netAmount
          category
          projectId
          projectName
          projectNumber
          costlineId
          costlineName
          costlineName_fr
        }
        taxAmountDetails {
          taxAmount
          vatAccount
          vatIntracom
        }
        netAmount
        ocrTotalAmount
        ocrTaxAmount
        ocrNetAmount
        currency
        ocrCurrency
        type
        status
        currentPage
        prevPage
        archivedDate
        category
        ocrCategory
        note
        ocrNote
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        poId
        quoteId
        supplierId
        costlineId
        projectId
        ocrStatus
        vatAccount
        ocrData {
          bucket
          region
          key
          identityId
        }
        invoiceKey
        paymentMethods
        vatIntracom
        bankAccountNumber
        paymentReference
        paymentReferenceType
        bankAccountName
        supplierAccountingNumber
        supplierAccountingName
        projectNumber
        quoteNumber
        lastExportedDate
        preparePurchaseToPayDate
        fullPurchaseNumber
        bridgePaymentLinkId
        billitInboxItemId
        billitPeppolFileId
        billitSenderPeppolId
        billitImportDate
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    miscAccNo
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedQuery<
		APITypes.GetBankTransactionsQueryVariables,
		APITypes.GetBankTransactionsQuery
	>
export const listBankTransactions = /* GraphQL */ `query ListBankTransactions(
  $filter: ModelBankTransactionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listBankTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      flag
      clean_description
      bank_description
      amount
      date
      updated_at
      currency_code
      is_deleted
      category_id
      account_id
      account_name
      is_future
      show_client_side
      projectId
      projectName
      status
      tags
      transactionType
      uniqueTransactionId
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      preparePurchase {
        items {
          id
          tenantId
          activeFlag
          uniqueTransactionId
          flag
          invoiceName
          ocrInvoiceName
          fileName
          ocrFileName
          invoiceDate
          ocrInvoiceDate
          paymentDate
          ocrPaymentDate
          paymentStatus
          preparePurchasePaidDate
          supplier
          ocrSupplier
          po
          ocrPO
          costlineName
          costlineName_fr
          projectName
          totalAmount
          taxAmount
          netAmount
          ocrTotalAmount
          ocrTaxAmount
          ocrNetAmount
          currency
          ocrCurrency
          type
          status
          currentPage
          prevPage
          archivedDate
          category
          ocrCategory
          note
          ocrNote
          poId
          quoteId
          supplierId
          costlineId
          projectId
          ocrStatus
          vatAccount
          invoiceKey
          paymentMethods
          vatIntracom
          bankAccountNumber
          paymentReference
          paymentReferenceType
          bankAccountName
          supplierAccountingNumber
          supplierAccountingName
          projectNumber
          quoteNumber
          lastExportedDate
          preparePurchaseToPayDate
          fullPurchaseNumber
          bridgePaymentLinkId
          billitInboxItemId
          billitPeppolFileId
          billitSenderPeppolId
          billitImportDate
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      miscAccNo
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListBankTransactionsQueryVariables,
	APITypes.ListBankTransactionsQuery
>
export const bankTransactionsByTenantId =
	/* GraphQL */ `query BankTransactionsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelBankTransactionsFilterInput
  $limit: Int
  $nextToken: String
) {
  bankTransactionsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      flag
      clean_description
      bank_description
      amount
      date
      updated_at
      currency_code
      is_deleted
      category_id
      account_id
      account_name
      is_future
      show_client_side
      projectId
      projectName
      status
      tags
      transactionType
      uniqueTransactionId
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      preparePurchase {
        items {
          id
          tenantId
          activeFlag
          uniqueTransactionId
          flag
          invoiceName
          ocrInvoiceName
          fileName
          ocrFileName
          invoiceDate
          ocrInvoiceDate
          paymentDate
          ocrPaymentDate
          paymentStatus
          preparePurchasePaidDate
          supplier
          ocrSupplier
          po
          ocrPO
          costlineName
          costlineName_fr
          projectName
          totalAmount
          taxAmount
          netAmount
          ocrTotalAmount
          ocrTaxAmount
          ocrNetAmount
          currency
          ocrCurrency
          type
          status
          currentPage
          prevPage
          archivedDate
          category
          ocrCategory
          note
          ocrNote
          poId
          quoteId
          supplierId
          costlineId
          projectId
          ocrStatus
          vatAccount
          invoiceKey
          paymentMethods
          vatIntracom
          bankAccountNumber
          paymentReference
          paymentReferenceType
          bankAccountName
          supplierAccountingNumber
          supplierAccountingName
          projectNumber
          quoteNumber
          lastExportedDate
          preparePurchaseToPayDate
          fullPurchaseNumber
          bridgePaymentLinkId
          billitInboxItemId
          billitPeppolFileId
          billitSenderPeppolId
          billitImportDate
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      miscAccNo
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.BankTransactionsByTenantIdQueryVariables,
		APITypes.BankTransactionsByTenantIdQuery
	>
export const getBillitInboxTracker =
	/* GraphQL */ `query GetBillitInboxTracker($id: ID!) {
  getBillitInboxTracker(id: $id) {
    id
    tenantId
    billitInboxItemId
    billitPeppolFileId
    preparePurchaseId
    senderPeppolId
    documentType
    status
    errorMessage
    rawUblData
    responseType
    responseCode
    referencedDocumentId
    senderName
    receiverName
    statusReasonCode
    statusReason
    effectiveDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<
		APITypes.GetBillitInboxTrackerQueryVariables,
		APITypes.GetBillitInboxTrackerQuery
	>
export const listBillitInboxTrackers =
	/* GraphQL */ `query ListBillitInboxTrackers(
  $filter: ModelBillitInboxTrackerFilterInput
  $limit: Int
  $nextToken: String
) {
  listBillitInboxTrackers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      billitInboxItemId
      billitPeppolFileId
      preparePurchaseId
      senderPeppolId
      documentType
      status
      errorMessage
      rawUblData
      responseType
      responseCode
      referencedDocumentId
      senderName
      receiverName
      statusReasonCode
      statusReason
      effectiveDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ListBillitInboxTrackersQueryVariables,
		APITypes.ListBillitInboxTrackersQuery
	>
export const billitInboxTrackerByTenantId =
	/* GraphQL */ `query BillitInboxTrackerByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelBillitInboxTrackerFilterInput
  $limit: Int
  $nextToken: String
) {
  billitInboxTrackerByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      billitInboxItemId
      billitPeppolFileId
      preparePurchaseId
      senderPeppolId
      documentType
      status
      errorMessage
      rawUblData
      responseType
      responseCode
      referencedDocumentId
      senderName
      receiverName
      statusReasonCode
      statusReason
      effectiveDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.BillitInboxTrackerByTenantIdQueryVariables,
		APITypes.BillitInboxTrackerByTenantIdQuery
	>
export const billitInboxTrackerByInboxItemId =
	/* GraphQL */ `query BillitInboxTrackerByInboxItemId(
  $billitInboxItemId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelBillitInboxTrackerFilterInput
  $limit: Int
  $nextToken: String
) {
  billitInboxTrackerByInboxItemId(
    billitInboxItemId: $billitInboxItemId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      billitInboxItemId
      billitPeppolFileId
      preparePurchaseId
      senderPeppolId
      documentType
      status
      errorMessage
      rawUblData
      responseType
      responseCode
      referencedDocumentId
      senderName
      receiverName
      statusReasonCode
      statusReason
      effectiveDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.BillitInboxTrackerByInboxItemIdQueryVariables,
		APITypes.BillitInboxTrackerByInboxItemIdQuery
	>
export const getClients = /* GraphQL */ `query GetClients($id: ID!) {
  getClients(id: $id) {
    id
    name
    email
    tenantId
    parentTeamId
    offlineIds
    activeFlag
    teamCount
    projects {
      items {
        id
        name
        tenantId
        freelancers
        childFreelancers
        offlineIds
        parentProjectId
        parentClientId
        activeFlag
        type
        parentTeamId
        parentSubTeamId
        isSubTeam
        projectType
        projectGroup
        parentCompanyId
        projectNumber
        subTeamCount
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<APITypes.GetClientsQueryVariables, APITypes.GetClientsQuery>
export const listClients = /* GraphQL */ `query ListClients(
  $filter: ModelClientsFilterInput
  $limit: Int
  $nextToken: String
) {
  listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      email
      tenantId
      parentTeamId
      offlineIds
      activeFlag
      teamCount
      projects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          parentTeamId
          parentSubTeamId
          isSubTeam
          projectType
          projectGroup
          parentCompanyId
          projectNumber
          subTeamCount
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListClientsQueryVariables,
	APITypes.ListClientsQuery
>
export const clientsByTenantId = /* GraphQL */ `query ClientsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelClientsFilterInput
  $limit: Int
  $nextToken: String
) {
  clientsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      email
      tenantId
      parentTeamId
      offlineIds
      activeFlag
      teamCount
      projects {
        items {
          id
          name
          tenantId
          freelancers
          childFreelancers
          offlineIds
          parentProjectId
          parentClientId
          activeFlag
          type
          parentTeamId
          parentSubTeamId
          isSubTeam
          projectType
          projectGroup
          parentCompanyId
          projectNumber
          subTeamCount
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ClientsByTenantIdQueryVariables,
	APITypes.ClientsByTenantIdQuery
>
export const getComments = /* GraphQL */ `query GetComments($id: ID!) {
  getComments(id: $id) {
    id
    quoteId
    activeFlag
    text
    parentId
    sectionId
    ownerEmail
    ownerSub
    status
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
	APITypes.GetCommentsQueryVariables,
	APITypes.GetCommentsQuery
>
export const listComments = /* GraphQL */ `query ListComments(
  $filter: ModelCommentsFilterInput
  $limit: Int
  $nextToken: String
) {
  listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      quoteId
      activeFlag
      text
      parentId
      sectionId
      ownerEmail
      ownerSub
      status
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListCommentsQueryVariables,
	APITypes.ListCommentsQuery
>
export const commentsByQuoteId = /* GraphQL */ `query CommentsByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCommentsFilterInput
  $limit: Int
  $nextToken: String
) {
  commentsByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      activeFlag
      text
      parentId
      sectionId
      ownerEmail
      ownerSub
      status
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.CommentsByQuoteIdQueryVariables,
	APITypes.CommentsByQuoteIdQuery
>
export const getCompany = /* GraphQL */ `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    tenantId
    name
    email
    phone
    website
    registrationNumber
    vatNumber
    addressLine1
    addressLine2
    pdfPrimaryColor
    pdfSecondaryColor
    logoImage {
      bucket
      region
      key
      identityId
    }
    logoImage2 {
      bucket
      region
      key
      identityId
    }
    logoImage3 {
      bucket
      region
      key
      identityId
    }
    logoImage4 {
      bucket
      region
      key
      identityId
    }
    logoImageText
    logoImage2Text
    logoImage3Text
    logoImage4Text
    invoiceCount
    purchaseOrderInvoiceCount
    invoicingYear
    bank
    iban
    bic
    accountName
    bankProfileName
    bankProfileName2
    bank2
    iban2
    bic2
    accountName2
    bankProfileName3
    bank3
    iban3
    bic3
    accountName3
    bankProfileName4
    bank4
    iban4
    bic4
    accountName4
    bankProfileName5
    bank5
    iban5
    bic5
    accountName5
    accountCurrency
    country
    duplicateQuoteCounter
    exportInfo {
      exportDate
      user
    }
    companyEmailId
    createPurchaseRecap
    termsAndCondition1
    termsAndCondition2
    poTANDC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC1 {
      bucket
      region
      key
      identityId
    }
    soundProdTAndC2 {
      bucket
      region
      key
      identityId
    }
    editorialTAndC {
      bucket
      region
      key
      identityId
    }
    commercialTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeTAndC {
      bucket
      region
      key
      identityId
    }
    editorialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    commercialEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    setDesignEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    wardrobeEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    digitalTAndC {
      bucket
      region
      key
      identityId
    }
    animationTAndC {
      bucket
      region
      key
      identityId
    }
    animationEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC1 {
      bucket
      region
      key
      identityId
    }
    frenchApfpTAndC2 {
      bucket
      region
      key
      identityId
    }
    blankQuoteTAndC {
      bucket
      region
      key
      identityId
    }
    blankQuoteEnglishTAndC {
      bucket
      region
      key
      identityId
    }
    aicpTAndC {
      bucket
      region
      key
      identityId
    }
    purchaseTags {
      title
      color
    }
    favouriteProjects {
      id
      name
      selectedDate
    }
    teamCount
    subTeamCount
    projectCount {
      type
      count
      year
      name
    }
    projectGroupCount {
      type
      count
      year
      name
    }
    quoteCount {
      type
      count
      year
      name
    }
    quoteTemplateDetails {
      type
      quoteId
      parentTeamId
      parentSubTeamId
      quoteName
    }
    quoteAccountingCategoryAllow
    quoteAccountingCategory {
      name
    }
    quoteTertiaryCategoryAllow
    quoteTertiaryCategory {
      name
    }
    taxRateType
    salesAccNumberType
    salesAccByCostlineDetails {
      id
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    salesAccQuoteTypeDetails {
      type
      EUName
      EUNumber
      InternationalName
      InternationalNumber
      LocalName
      LocalNumber
    }
    aicpEUName
    aicpEUNumber
    aicpInternationalName
    aicpInternationalNumber
    aicpLocalName
    aicpLocalNumber
    apfpEUName
    apfpEUNumber
    apfpInternationalName
    apfpInternationalNumber
    apfpLocalName
    apfpLocalNumber
    photoEUName
    photoEUNumber
    photoInternationalName
    photoInternationalNumber
    photoLocalName
    photoLocalNumber
    postProdEUName
    postProdEUNumber
    postProdInternationalName
    postProdInternationalNumber
    postProdLocalName
    postProdLocalNumber
    vat20
    vat10
    specialEnglishInvoiceNote
    specialFrenchInvoiceNote
    costCategoriesFields {
      id
      name
    }
    costVatFields {
      number
      name
      text
    }
    miscAccNosFields {
      name
      number
      text
    }
    clientsSubAcc
    suppliersSubAcc
    userBridgeApiLoginDetails {
      uuid
      email
    }
    userBankingAutehticationDetails {
      access_token
      expires_at
      user {
        uuid
        email
      }
    }
    isLoggedIntoBanking
    lastUpdatedTransactionDate
    vatIntracom {
      type
      debitNumber
      debitName
      creditNumber
      creditName
    }
    sendCostlinesToReviewPage
    sendOverheadsToReviewPage
    activateDeliveryDate
    defaultProjectType
    paymentTerms
    localOtNumberOfHours
    exeOtNumberOfHours
    projectNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneProjectNumber
    commonProjectNumber
    individualSuppliersSubAcc
    clientsSalesAccountNumber
    suppliersCostAccountNumber
    quoteNumberCustomisation {
      seperator
      first
      second
      third
    }
    useOneQuoteNumber
    commonQuoteNumber
    commonProjectGroupFlag
    commonProjectGroup
    restrictProjectGroup
    salesLedgerName
    purchasesLedgerName
    ledgerNames {
      bankProfileName
      bridgeBankAccountId
      number
      name
      label
    }
    quoteJsonDetails {
      name
      quoteType
      categories {
        Bucket
        Key
        identityId
      }
      subcategories {
        Bucket
        Key
        identityId
      }
      costline {
        Bucket
        Key
        identityId
      }
    }
    purchaseCount
    invoiceNumberPrefix
    poNumberPrefix
    emailTemplateArray {
      id
      language
      name
      subject
      body
    }
    billitPartyId
    billitApiKey
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<APITypes.GetCompanyQueryVariables, APITypes.GetCompanyQuery>
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      name
      email
      phone
      website
      registrationNumber
      vatNumber
      addressLine1
      addressLine2
      pdfPrimaryColor
      pdfSecondaryColor
      logoImage {
        bucket
        region
        key
        identityId
      }
      logoImage2 {
        bucket
        region
        key
        identityId
      }
      logoImage3 {
        bucket
        region
        key
        identityId
      }
      logoImage4 {
        bucket
        region
        key
        identityId
      }
      logoImageText
      logoImage2Text
      logoImage3Text
      logoImage4Text
      invoiceCount
      purchaseOrderInvoiceCount
      invoicingYear
      bank
      iban
      bic
      accountName
      bankProfileName
      bankProfileName2
      bank2
      iban2
      bic2
      accountName2
      bankProfileName3
      bank3
      iban3
      bic3
      accountName3
      bankProfileName4
      bank4
      iban4
      bic4
      accountName4
      bankProfileName5
      bank5
      iban5
      bic5
      accountName5
      accountCurrency
      country
      duplicateQuoteCounter
      exportInfo {
        exportDate
        user
      }
      companyEmailId
      createPurchaseRecap
      termsAndCondition1
      termsAndCondition2
      poTANDC1 {
        bucket
        region
        key
        identityId
      }
      soundProdTAndC1 {
        bucket
        region
        key
        identityId
      }
      soundProdTAndC2 {
        bucket
        region
        key
        identityId
      }
      editorialTAndC {
        bucket
        region
        key
        identityId
      }
      commercialTAndC {
        bucket
        region
        key
        identityId
      }
      setDesignTAndC {
        bucket
        region
        key
        identityId
      }
      wardrobeTAndC {
        bucket
        region
        key
        identityId
      }
      editorialEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      commercialEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      setDesignEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      wardrobeEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      digitalTAndC {
        bucket
        region
        key
        identityId
      }
      animationTAndC {
        bucket
        region
        key
        identityId
      }
      animationEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      frenchApfpTAndC1 {
        bucket
        region
        key
        identityId
      }
      frenchApfpTAndC2 {
        bucket
        region
        key
        identityId
      }
      blankQuoteTAndC {
        bucket
        region
        key
        identityId
      }
      blankQuoteEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      aicpTAndC {
        bucket
        region
        key
        identityId
      }
      purchaseTags {
        title
        color
      }
      favouriteProjects {
        id
        name
        selectedDate
      }
      teamCount
      subTeamCount
      projectCount {
        type
        count
        year
        name
      }
      projectGroupCount {
        type
        count
        year
        name
      }
      quoteCount {
        type
        count
        year
        name
      }
      quoteTemplateDetails {
        type
        quoteId
        parentTeamId
        parentSubTeamId
        quoteName
      }
      quoteAccountingCategoryAllow
      quoteAccountingCategory {
        name
      }
      quoteTertiaryCategoryAllow
      quoteTertiaryCategory {
        name
      }
      taxRateType
      salesAccNumberType
      salesAccByCostlineDetails {
        id
        EUName
        EUNumber
        InternationalName
        InternationalNumber
        LocalName
        LocalNumber
      }
      salesAccQuoteTypeDetails {
        type
        EUName
        EUNumber
        InternationalName
        InternationalNumber
        LocalName
        LocalNumber
      }
      aicpEUName
      aicpEUNumber
      aicpInternationalName
      aicpInternationalNumber
      aicpLocalName
      aicpLocalNumber
      apfpEUName
      apfpEUNumber
      apfpInternationalName
      apfpInternationalNumber
      apfpLocalName
      apfpLocalNumber
      photoEUName
      photoEUNumber
      photoInternationalName
      photoInternationalNumber
      photoLocalName
      photoLocalNumber
      postProdEUName
      postProdEUNumber
      postProdInternationalName
      postProdInternationalNumber
      postProdLocalName
      postProdLocalNumber
      vat20
      vat10
      specialEnglishInvoiceNote
      specialFrenchInvoiceNote
      costCategoriesFields {
        id
        name
      }
      costVatFields {
        number
        name
        text
      }
      miscAccNosFields {
        name
        number
        text
      }
      clientsSubAcc
      suppliersSubAcc
      userBridgeApiLoginDetails {
        uuid
        email
      }
      userBankingAutehticationDetails {
        access_token
        expires_at
        user {
          uuid
          email
        }
      }
      isLoggedIntoBanking
      lastUpdatedTransactionDate
      vatIntracom {
        type
        debitNumber
        debitName
        creditNumber
        creditName
      }
      sendCostlinesToReviewPage
      sendOverheadsToReviewPage
      activateDeliveryDate
      defaultProjectType
      paymentTerms
      localOtNumberOfHours
      exeOtNumberOfHours
      projectNumberCustomisation {
        seperator
        first
        second
        third
      }
      useOneProjectNumber
      commonProjectNumber
      individualSuppliersSubAcc
      clientsSalesAccountNumber
      suppliersCostAccountNumber
      quoteNumberCustomisation {
        seperator
        first
        second
        third
      }
      useOneQuoteNumber
      commonQuoteNumber
      commonProjectGroupFlag
      commonProjectGroup
      restrictProjectGroup
      salesLedgerName
      purchasesLedgerName
      ledgerNames {
        bankProfileName
        bridgeBankAccountId
        number
        name
        label
      }
      quoteJsonDetails {
        name
        quoteType
        categories {
          Bucket
          Key
          identityId
        }
        subcategories {
          Bucket
          Key
          identityId
        }
        costline {
          Bucket
          Key
          identityId
        }
      }
      purchaseCount
      invoiceNumberPrefix
      poNumberPrefix
      emailTemplateArray {
        id
        language
        name
        subject
        body
      }
      billitPartyId
      billitApiKey
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListCompaniesQueryVariables,
	APITypes.ListCompaniesQuery
>
export const companyByEmailId = /* GraphQL */ `query CompanyByEmailId(
  $companyEmailId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  companyByEmailId(
    companyEmailId: $companyEmailId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      name
      email
      phone
      website
      registrationNumber
      vatNumber
      addressLine1
      addressLine2
      pdfPrimaryColor
      pdfSecondaryColor
      logoImage {
        bucket
        region
        key
        identityId
      }
      logoImage2 {
        bucket
        region
        key
        identityId
      }
      logoImage3 {
        bucket
        region
        key
        identityId
      }
      logoImage4 {
        bucket
        region
        key
        identityId
      }
      logoImageText
      logoImage2Text
      logoImage3Text
      logoImage4Text
      invoiceCount
      purchaseOrderInvoiceCount
      invoicingYear
      bank
      iban
      bic
      accountName
      bankProfileName
      bankProfileName2
      bank2
      iban2
      bic2
      accountName2
      bankProfileName3
      bank3
      iban3
      bic3
      accountName3
      bankProfileName4
      bank4
      iban4
      bic4
      accountName4
      bankProfileName5
      bank5
      iban5
      bic5
      accountName5
      accountCurrency
      country
      duplicateQuoteCounter
      exportInfo {
        exportDate
        user
      }
      companyEmailId
      createPurchaseRecap
      termsAndCondition1
      termsAndCondition2
      poTANDC1 {
        bucket
        region
        key
        identityId
      }
      soundProdTAndC1 {
        bucket
        region
        key
        identityId
      }
      soundProdTAndC2 {
        bucket
        region
        key
        identityId
      }
      editorialTAndC {
        bucket
        region
        key
        identityId
      }
      commercialTAndC {
        bucket
        region
        key
        identityId
      }
      setDesignTAndC {
        bucket
        region
        key
        identityId
      }
      wardrobeTAndC {
        bucket
        region
        key
        identityId
      }
      editorialEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      commercialEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      setDesignEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      wardrobeEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      digitalTAndC {
        bucket
        region
        key
        identityId
      }
      animationTAndC {
        bucket
        region
        key
        identityId
      }
      animationEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      frenchApfpTAndC1 {
        bucket
        region
        key
        identityId
      }
      frenchApfpTAndC2 {
        bucket
        region
        key
        identityId
      }
      blankQuoteTAndC {
        bucket
        region
        key
        identityId
      }
      blankQuoteEnglishTAndC {
        bucket
        region
        key
        identityId
      }
      aicpTAndC {
        bucket
        region
        key
        identityId
      }
      purchaseTags {
        title
        color
      }
      favouriteProjects {
        id
        name
        selectedDate
      }
      teamCount
      subTeamCount
      projectCount {
        type
        count
        year
        name
      }
      projectGroupCount {
        type
        count
        year
        name
      }
      quoteCount {
        type
        count
        year
        name
      }
      quoteTemplateDetails {
        type
        quoteId
        parentTeamId
        parentSubTeamId
        quoteName
      }
      quoteAccountingCategoryAllow
      quoteAccountingCategory {
        name
      }
      quoteTertiaryCategoryAllow
      quoteTertiaryCategory {
        name
      }
      taxRateType
      salesAccNumberType
      salesAccByCostlineDetails {
        id
        EUName
        EUNumber
        InternationalName
        InternationalNumber
        LocalName
        LocalNumber
      }
      salesAccQuoteTypeDetails {
        type
        EUName
        EUNumber
        InternationalName
        InternationalNumber
        LocalName
        LocalNumber
      }
      aicpEUName
      aicpEUNumber
      aicpInternationalName
      aicpInternationalNumber
      aicpLocalName
      aicpLocalNumber
      apfpEUName
      apfpEUNumber
      apfpInternationalName
      apfpInternationalNumber
      apfpLocalName
      apfpLocalNumber
      photoEUName
      photoEUNumber
      photoInternationalName
      photoInternationalNumber
      photoLocalName
      photoLocalNumber
      postProdEUName
      postProdEUNumber
      postProdInternationalName
      postProdInternationalNumber
      postProdLocalName
      postProdLocalNumber
      vat20
      vat10
      specialEnglishInvoiceNote
      specialFrenchInvoiceNote
      costCategoriesFields {
        id
        name
      }
      costVatFields {
        number
        name
        text
      }
      miscAccNosFields {
        name
        number
        text
      }
      clientsSubAcc
      suppliersSubAcc
      userBridgeApiLoginDetails {
        uuid
        email
      }
      userBankingAutehticationDetails {
        access_token
        expires_at
        user {
          uuid
          email
        }
      }
      isLoggedIntoBanking
      lastUpdatedTransactionDate
      vatIntracom {
        type
        debitNumber
        debitName
        creditNumber
        creditName
      }
      sendCostlinesToReviewPage
      sendOverheadsToReviewPage
      activateDeliveryDate
      defaultProjectType
      paymentTerms
      localOtNumberOfHours
      exeOtNumberOfHours
      projectNumberCustomisation {
        seperator
        first
        second
        third
      }
      useOneProjectNumber
      commonProjectNumber
      individualSuppliersSubAcc
      clientsSalesAccountNumber
      suppliersCostAccountNumber
      quoteNumberCustomisation {
        seperator
        first
        second
        third
      }
      useOneQuoteNumber
      commonQuoteNumber
      commonProjectGroupFlag
      commonProjectGroup
      restrictProjectGroup
      salesLedgerName
      purchasesLedgerName
      ledgerNames {
        bankProfileName
        bridgeBankAccountId
        number
        name
        label
      }
      quoteJsonDetails {
        name
        quoteType
        categories {
          Bucket
          Key
          identityId
        }
        subcategories {
          Bucket
          Key
          identityId
        }
        costline {
          Bucket
          Key
          identityId
        }
      }
      purchaseCount
      invoiceNumberPrefix
      poNumberPrefix
      emailTemplateArray {
        id
        language
        name
        subject
        body
      }
      billitPartyId
      billitApiKey
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.CompanyByEmailIdQueryVariables,
	APITypes.CompanyByEmailIdQuery
>
export const getCompanyQuoteTemplate =
	/* GraphQL */ `query GetCompanyQuoteTemplate($id: ID!) {
  getCompanyQuoteTemplate(id: $id) {
    id
    tenantId
    quoteId
    teamIds
    subTeamIds
    name
    quoteType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
		APITypes.GetCompanyQuoteTemplateQueryVariables,
		APITypes.GetCompanyQuoteTemplateQuery
	>
export const listCompanyQuoteTemplates =
	/* GraphQL */ `query ListCompanyQuoteTemplates(
  $filter: ModelCompanyQuoteTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyQuoteTemplates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      teamIds
      subTeamIds
      name
      quoteType
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ListCompanyQuoteTemplatesQueryVariables,
		APITypes.ListCompanyQuoteTemplatesQuery
	>
export const companyQuoteTemplateByTenantId =
	/* GraphQL */ `query CompanyQuoteTemplateByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyQuoteTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  companyQuoteTemplateByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      teamIds
      subTeamIds
      name
      quoteType
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.CompanyQuoteTemplateByTenantIdQueryVariables,
		APITypes.CompanyQuoteTemplateByTenantIdQuery
	>
export const companyQuoteTemplateByQuoteId =
	/* GraphQL */ `query CompanyQuoteTemplateByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCompanyQuoteTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  companyQuoteTemplateByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      teamIds
      subTeamIds
      name
      quoteType
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.CompanyQuoteTemplateByQuoteIdQueryVariables,
		APITypes.CompanyQuoteTemplateByQuoteIdQuery
	>
export const getContact = /* GraphQL */ `query GetContact($id: ID!) {
  getContact(id: $id) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    email
    contactPhone
    contactDetails {
      id
      fullName
      email
      phone
    }
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    clientSubAccount
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedQuery<APITypes.GetContactQueryVariables, APITypes.GetContactQuery>
export const listContacts = /* GraphQL */ `query ListContacts(
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      email
      contactPhone
      contactDetails {
        id
        fullName
        email
        phone
      }
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      thirdPartyAccounts
      note
      bank
      iban
      bic
      accountName
      clientSubAccount
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListContactsQueryVariables,
	APITypes.ListContactsQuery
>
export const contactsByTenantId = /* GraphQL */ `query ContactsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
) {
  contactsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      email
      contactPhone
      contactDetails {
        id
        fullName
        email
        phone
      }
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      thirdPartyAccounts
      note
      bank
      iban
      bic
      accountName
      clientSubAccount
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ContactsByTenantIdQueryVariables,
	APITypes.ContactsByTenantIdQuery
>
export const getCurrencyRate = /* GraphQL */ `query GetCurrencyRate($id: ID!) {
  getCurrencyRate(id: $id) {
    id
    tenantId
    activeFlag
    base
    date
    rates {
      currencyName
      currencyRate
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
	APITypes.GetCurrencyRateQueryVariables,
	APITypes.GetCurrencyRateQuery
>
export const listCurrencyRates = /* GraphQL */ `query ListCurrencyRates(
  $filter: ModelCurrencyRateFilterInput
  $limit: Int
  $nextToken: String
) {
  listCurrencyRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      base
      date
      rates {
        currencyName
        currencyRate
      }
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListCurrencyRatesQueryVariables,
	APITypes.ListCurrencyRatesQuery
>
export const currencyRateByTenantId =
	/* GraphQL */ `query CurrencyRateByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCurrencyRateFilterInput
  $limit: Int
  $nextToken: String
) {
  currencyRateByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      base
      date
      rates {
        currencyName
        currencyRate
      }
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.CurrencyRateByTenantIdQueryVariables,
		APITypes.CurrencyRateByTenantIdQuery
	>
export const getExportInfo = /* GraphQL */ `query GetExportInfo($id: ID!) {
  getExportInfo(id: $id) {
    id
    tenantId
    activeFlag
    name
    exportDate
    exportType
    loggedLineId
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedQuery<
	APITypes.GetExportInfoQueryVariables,
	APITypes.GetExportInfoQuery
>
export const listExportInfos = /* GraphQL */ `query ListExportInfos(
  $filter: ModelExportInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listExportInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      name
      exportDate
      exportType
      loggedLineId
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListExportInfosQueryVariables,
	APITypes.ListExportInfosQuery
>
export const exportInfoByTenantId = /* GraphQL */ `query ExportInfoByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelExportInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  exportInfoByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      name
      exportDate
      exportType
      loggedLineId
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ExportInfoByTenantIdQueryVariables,
	APITypes.ExportInfoByTenantIdQuery
>
export const getFilledCostlines =
	/* GraphQL */ `query GetFilledCostlines($id: ID!) {
  getFilledCostlines(id: $id) {
    id
    tenantId
    quoteId
    item
    item_fr
    quantity
    number
    shootNumber
    rate
    rateInEuros
    total
    overheadPercentage
    marginPercentage
    costlineUuid
    costLineType
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
		APITypes.GetFilledCostlinesQueryVariables,
		APITypes.GetFilledCostlinesQuery
	>
export const listFilledCostlines = /* GraphQL */ `query ListFilledCostlines(
  $filter: ModelFilledCostlinesFilterInput
  $limit: Int
  $nextToken: String
) {
  listFilledCostlines(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      quoteId
      item
      item_fr
      quantity
      number
      shootNumber
      rate
      rateInEuros
      total
      overheadPercentage
      marginPercentage
      costlineUuid
      costLineType
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListFilledCostlinesQueryVariables,
	APITypes.ListFilledCostlinesQuery
>
export const filledCostlinesByTenantId =
	/* GraphQL */ `query FilledCostlinesByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFilledCostlinesFilterInput
  $limit: Int
  $nextToken: String
) {
  filledCostlinesByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      item
      item_fr
      quantity
      number
      shootNumber
      rate
      rateInEuros
      total
      overheadPercentage
      marginPercentage
      costlineUuid
      costLineType
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.FilledCostlinesByTenantIdQueryVariables,
		APITypes.FilledCostlinesByTenantIdQuery
	>
export const filledCostlinesByQuoteId =
	/* GraphQL */ `query FilledCostlinesByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFilledCostlinesFilterInput
  $limit: Int
  $nextToken: String
) {
  filledCostlinesByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      item
      item_fr
      quantity
      number
      shootNumber
      rate
      rateInEuros
      total
      overheadPercentage
      marginPercentage
      costlineUuid
      costLineType
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.FilledCostlinesByQuoteIdQueryVariables,
		APITypes.FilledCostlinesByQuoteIdQuery
	>
export const getFreelancerBilling =
	/* GraphQL */ `query GetFreelancerBilling($id: ID!) {
  getFreelancerBilling(id: $id) {
    id
    tenantId
    projectId
    freelancerId
    projectFreelancerKey
    stripeInvoiceId
    stripeLineItemId
    stripeRefundId
    stripePriceId
    stripePriceAmount
    status
    chargedAt
    chargeScheduledAt
    chargeSchedulerName
    refundEligibleUntil
    refundedAt
    stripeCreditNoteId
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
		APITypes.GetFreelancerBillingQueryVariables,
		APITypes.GetFreelancerBillingQuery
	>
export const listFreelancerBillings =
	/* GraphQL */ `query ListFreelancerBillings(
  $filter: ModelFreelancerBillingFilterInput
  $limit: Int
  $nextToken: String
) {
  listFreelancerBillings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      projectId
      freelancerId
      projectFreelancerKey
      stripeInvoiceId
      stripeLineItemId
      stripeRefundId
      stripePriceId
      stripePriceAmount
      status
      chargedAt
      chargeScheduledAt
      chargeSchedulerName
      refundEligibleUntil
      refundedAt
      stripeCreditNoteId
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ListFreelancerBillingsQueryVariables,
		APITypes.ListFreelancerBillingsQuery
	>
export const freelancerBillingByTenantId =
	/* GraphQL */ `query FreelancerBillingByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFreelancerBillingFilterInput
  $limit: Int
  $nextToken: String
) {
  freelancerBillingByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      projectId
      freelancerId
      projectFreelancerKey
      stripeInvoiceId
      stripeLineItemId
      stripeRefundId
      stripePriceId
      stripePriceAmount
      status
      chargedAt
      chargeScheduledAt
      chargeSchedulerName
      refundEligibleUntil
      refundedAt
      stripeCreditNoteId
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.FreelancerBillingByTenantIdQueryVariables,
		APITypes.FreelancerBillingByTenantIdQuery
	>
export const freelancerBillingByProjectId =
	/* GraphQL */ `query FreelancerBillingByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFreelancerBillingFilterInput
  $limit: Int
  $nextToken: String
) {
  freelancerBillingByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      projectId
      freelancerId
      projectFreelancerKey
      stripeInvoiceId
      stripeLineItemId
      stripeRefundId
      stripePriceId
      stripePriceAmount
      status
      chargedAt
      chargeScheduledAt
      chargeSchedulerName
      refundEligibleUntil
      refundedAt
      stripeCreditNoteId
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.FreelancerBillingByProjectIdQueryVariables,
		APITypes.FreelancerBillingByProjectIdQuery
	>
export const freelancerBillingByFreelancerId =
	/* GraphQL */ `query FreelancerBillingByFreelancerId(
  $freelancerId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFreelancerBillingFilterInput
  $limit: Int
  $nextToken: String
) {
  freelancerBillingByFreelancerId(
    freelancerId: $freelancerId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      projectId
      freelancerId
      projectFreelancerKey
      stripeInvoiceId
      stripeLineItemId
      stripeRefundId
      stripePriceId
      stripePriceAmount
      status
      chargedAt
      chargeScheduledAt
      chargeSchedulerName
      refundEligibleUntil
      refundedAt
      stripeCreditNoteId
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.FreelancerBillingByFreelancerIdQueryVariables,
		APITypes.FreelancerBillingByFreelancerIdQuery
	>
export const freelancerBillingByProjectFreelancer =
	/* GraphQL */ `query FreelancerBillingByProjectFreelancer(
  $projectFreelancerKey: String!
  $sortDirection: ModelSortDirection
  $filter: ModelFreelancerBillingFilterInput
  $limit: Int
  $nextToken: String
) {
  freelancerBillingByProjectFreelancer(
    projectFreelancerKey: $projectFreelancerKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      projectId
      freelancerId
      projectFreelancerKey
      stripeInvoiceId
      stripeLineItemId
      stripeRefundId
      stripePriceId
      stripePriceAmount
      status
      chargedAt
      chargeScheduledAt
      chargeSchedulerName
      refundEligibleUntil
      refundedAt
      stripeCreditNoteId
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.FreelancerBillingByProjectFreelancerQueryVariables,
		APITypes.FreelancerBillingByProjectFreelancerQuery
	>
export const getFreelancers = /* GraphQL */ `query GetFreelancers($id: ID!) {
  getFreelancers(id: $id) {
    id
    email
    name
    freelancerTenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    profileImage {
      bucket
      region
      key
      identityId
    }
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
	APITypes.GetFreelancersQueryVariables,
	APITypes.GetFreelancersQuery
>
export const listFreelancers = /* GraphQL */ `query ListFreelancers(
  $filter: ModelFreelancersFilterInput
  $limit: Int
  $nextToken: String
) {
  listFreelancers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      profileImage {
        bucket
        region
        key
        identityId
      }
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListFreelancersQueryVariables,
	APITypes.ListFreelancersQuery
>
export const freelancersByEmail = /* GraphQL */ `query FreelancersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelFreelancersFilterInput
  $limit: Int
  $nextToken: String
) {
  freelancersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      profileImage {
        bucket
        region
        key
        identityId
      }
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.FreelancersByEmailQueryVariables,
	APITypes.FreelancersByEmailQuery
>
export const freelancersById = /* GraphQL */ `query FreelancersById(
  $freelancerTenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFreelancersFilterInput
  $limit: Int
  $nextToken: String
) {
  freelancersById(
    freelancerTenantId: $freelancerTenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      name
      freelancerTenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      profileImage {
        bucket
        region
        key
        identityId
      }
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.FreelancersByIdQueryVariables,
	APITypes.FreelancersByIdQuery
>
export const getInvoices = /* GraphQL */ `query GetInvoices($id: ID!) {
  getInvoices(id: $id) {
    id
    tenantId
    proposalId
    quoteType
    activeFlag
    originalInvoiceId
    creditInvoiceGenerated
    archivedDate
    paidDate
    paymentStatus
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientId
    contactId
    clientName
    contactName
    clientTaxType
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    title
    invoiceNumber
    poNumber
    invoiceAmountPercentage
    amount
    amountAfterTax
    taxAmount
    balancePercentage
    balanceAmount
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    invoicesBankProfileName
    invoicesBank
    invoicesIban
    invoicesBic
    invoicesAccountName
    invoiceDate
    invoiceDueDate
    description
    creditComments
    invoiceType
    proposalsDraft {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    taxDetails {
      taxRate
      taxPercentage
      taxAmount
      taxableAmount
    }
    salesAccNumberType
    sectionDetails {
      type
      amount
    }
    sectionDetailsByQuote {
      type
      amount
    }
    sectionDetailsByAccSection {
      type
      amount
    }
    proposals {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    createdOn
    updatedOn
    uniqueTransactionId
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    lastExportedDate
    emailSent
    draftEmailData {
      toEmail
      toCC
      toBCC
      subject
      body
      template
    }
    emailHistory {
      date
      subject
    }
    billitInboxItemId
    billitPeppolStatus
    billitPeppolError
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<
	APITypes.GetInvoicesQueryVariables,
	APITypes.GetInvoicesQuery
>
export const listInvoices = /* GraphQL */ `query ListInvoices(
  $filter: ModelInvoicesFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      proposalId
      quoteType
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientId
      contactId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      createdOn
      updatedOn
      uniqueTransactionId
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      lastExportedDate
      emailSent
      draftEmailData {
        toEmail
        toCC
        toBCC
        subject
        body
        template
      }
      emailHistory {
        date
        subject
      }
      billitInboxItemId
      billitPeppolStatus
      billitPeppolError
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListInvoicesQueryVariables,
	APITypes.ListInvoicesQuery
>
export const invoicesByTenantId = /* GraphQL */ `query InvoicesByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoicesFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      proposalId
      quoteType
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientId
      contactId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      createdOn
      updatedOn
      uniqueTransactionId
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      lastExportedDate
      emailSent
      draftEmailData {
        toEmail
        toCC
        toBCC
        subject
        body
        template
      }
      emailHistory {
        date
        subject
      }
      billitInboxItemId
      billitPeppolStatus
      billitPeppolError
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.InvoicesByTenantIdQueryVariables,
	APITypes.InvoicesByTenantIdQuery
>
export const invoicesByProposalId = /* GraphQL */ `query InvoicesByProposalId(
  $proposalId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoicesFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByProposalId(
    proposalId: $proposalId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      proposalId
      quoteType
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientId
      contactId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      createdOn
      updatedOn
      uniqueTransactionId
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      lastExportedDate
      emailSent
      draftEmailData {
        toEmail
        toCC
        toBCC
        subject
        body
        template
      }
      emailHistory {
        date
        subject
      }
      billitInboxItemId
      billitPeppolStatus
      billitPeppolError
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.InvoicesByProposalIdQueryVariables,
	APITypes.InvoicesByProposalIdQuery
>
export const invoicesByContactId = /* GraphQL */ `query InvoicesByContactId(
  $clientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoicesFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByContactId(
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      proposalId
      quoteType
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientId
      contactId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      createdOn
      updatedOn
      uniqueTransactionId
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      lastExportedDate
      emailSent
      draftEmailData {
        toEmail
        toCC
        toBCC
        subject
        body
        template
      }
      emailHistory {
        date
        subject
      }
      billitInboxItemId
      billitPeppolStatus
      billitPeppolError
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.InvoicesByContactIdQueryVariables,
	APITypes.InvoicesByContactIdQuery
>
export const invoicesByTransactionId =
	/* GraphQL */ `query InvoicesByTransactionId(
  $uniqueTransactionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoicesFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByTransactionId(
    uniqueTransactionId: $uniqueTransactionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      proposalId
      quoteType
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientId
      contactId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      createdOn
      updatedOn
      uniqueTransactionId
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      lastExportedDate
      emailSent
      draftEmailData {
        toEmail
        toCC
        toBCC
        subject
        body
        template
      }
      emailHistory {
        date
        subject
      }
      billitInboxItemId
      billitPeppolStatus
      billitPeppolError
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.InvoicesByTransactionIdQueryVariables,
		APITypes.InvoicesByTransactionIdQuery
	>
export const invoicesByAssignedTenantId =
	/* GraphQL */ `query InvoicesByAssignedTenantId(
  $assignedTenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoicesFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByAssignedTenantId(
    assignedTenantId: $assignedTenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      proposalId
      quoteType
      activeFlag
      originalInvoiceId
      creditInvoiceGenerated
      archivedDate
      paidDate
      paymentStatus
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientId
      contactId
      clientName
      contactName
      clientTaxType
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      title
      invoiceNumber
      poNumber
      invoiceAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      invoicesBankProfileName
      invoicesBank
      invoicesIban
      invoicesBic
      invoicesAccountName
      invoiceDate
      invoiceDueDate
      description
      creditComments
      invoiceType
      proposalsDraft {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
      proposals {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      createdOn
      updatedOn
      uniqueTransactionId
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      lastExportedDate
      emailSent
      draftEmailData {
        toEmail
        toCC
        toBCC
        subject
        body
        template
      }
      emailHistory {
        date
        subject
      }
      billitInboxItemId
      billitPeppolStatus
      billitPeppolError
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.InvoicesByAssignedTenantIdQueryVariables,
		APITypes.InvoicesByAssignedTenantIdQuery
	>
export const getLlmDetails = /* GraphQL */ `query GetLlmDetails($id: ID!) {
  getLlmDetails(id: $id) {
    id
    tenantId
    quoteId
    systemPrompt
    userPrompt
    temperature
    maxTokens
    generatedOutput
    generatedPromptQuoteKey
    runType
    runStatus
    runTypeStatus
    auditS3Key
    modelId
    inputTokens
    outputTokens
    totalTokens
    estimatedCostUsd
    startedAt
    completedAt
    errorCode
    errorMessage
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
	APITypes.GetLlmDetailsQueryVariables,
	APITypes.GetLlmDetailsQuery
>
export const listLlmDetails = /* GraphQL */ `query ListLlmDetails(
  $filter: ModelLlmDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listLlmDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      quoteId
      systemPrompt
      userPrompt
      temperature
      maxTokens
      generatedOutput
      generatedPromptQuoteKey
      runType
      runStatus
      runTypeStatus
      auditS3Key
      modelId
      inputTokens
      outputTokens
      totalTokens
      estimatedCostUsd
      startedAt
      completedAt
      errorCode
      errorMessage
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListLlmDetailsQueryVariables,
	APITypes.ListLlmDetailsQuery
>
export const llmDetailsByTenantId = /* GraphQL */ `query LlmDetailsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLlmDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  llmDetailsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      systemPrompt
      userPrompt
      temperature
      maxTokens
      generatedOutput
      generatedPromptQuoteKey
      runType
      runStatus
      runTypeStatus
      auditS3Key
      modelId
      inputTokens
      outputTokens
      totalTokens
      estimatedCostUsd
      startedAt
      completedAt
      errorCode
      errorMessage
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.LlmDetailsByTenantIdQueryVariables,
	APITypes.LlmDetailsByTenantIdQuery
>
export const llmDetailsByQuoteId = /* GraphQL */ `query LlmDetailsByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLlmDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  llmDetailsByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      quoteId
      systemPrompt
      userPrompt
      temperature
      maxTokens
      generatedOutput
      generatedPromptQuoteKey
      runType
      runStatus
      runTypeStatus
      auditS3Key
      modelId
      inputTokens
      outputTokens
      totalTokens
      estimatedCostUsd
      startedAt
      completedAt
      errorCode
      errorMessage
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.LlmDetailsByQuoteIdQueryVariables,
	APITypes.LlmDetailsByQuoteIdQuery
>
export const getPreparePurchase =
	/* GraphQL */ `query GetPreparePurchase($id: ID!) {
  getPreparePurchase(id: $id) {
    id
    tenantId
    activeFlag
    uniqueTransactionId
    flag
    invoiceName
    ocrInvoiceName
    fileName
    ocrFileName
    invoiceDate
    ocrInvoiceDate
    paymentDate
    ocrPaymentDate
    paymentStatus
    preparePurchasePaidDate
    supplier
    ocrSupplier
    po
    ocrPO
    costlineName
    costlineName_fr
    projectName
    totalAmount
    taxAmount
    netAmountDetails {
      netAmount
      category
      projectId
      projectName
      projectNumber
      costlineId
      costlineName
      costlineName_fr
    }
    taxAmountDetails {
      taxAmount
      vatAccount
      vatIntracom
    }
    netAmount
    ocrTotalAmount
    ocrTaxAmount
    ocrNetAmount
    currency
    ocrCurrency
    type
    status
    currentPage
    prevPage
    archivedDate
    category
    ocrCategory
    note
    ocrNote
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poId
    quoteId
    supplierId
    costlineId
    projectId
    ocrStatus
    vatAccount
    ocrData {
      bucket
      region
      key
      identityId
    }
    invoiceKey
    paymentMethods
    vatIntracom
    bankAccountNumber
    paymentReference
    paymentReferenceType
    bankAccountName
    supplierAccountingNumber
    supplierAccountingName
    projectNumber
    quoteNumber
    lastExportedDate
    preparePurchaseToPayDate
    fullPurchaseNumber
    bridgePaymentLinkId
    billitInboxItemId
    billitPeppolFileId
    billitSenderPeppolId
    billitImportDate
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<
		APITypes.GetPreparePurchaseQueryVariables,
		APITypes.GetPreparePurchaseQuery
	>
export const listPreparePurchases = /* GraphQL */ `query ListPreparePurchases(
  $filter: ModelPreparePurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listPreparePurchases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      uniqueTransactionId
      flag
      invoiceName
      ocrInvoiceName
      fileName
      ocrFileName
      invoiceDate
      ocrInvoiceDate
      paymentDate
      ocrPaymentDate
      paymentStatus
      preparePurchasePaidDate
      supplier
      ocrSupplier
      po
      ocrPO
      costlineName
      costlineName_fr
      projectName
      totalAmount
      taxAmount
      netAmountDetails {
        netAmount
        category
        projectId
        projectName
        projectNumber
        costlineId
        costlineName
        costlineName_fr
      }
      taxAmountDetails {
        taxAmount
        vatAccount
        vatIntracom
      }
      netAmount
      ocrTotalAmount
      ocrTaxAmount
      ocrNetAmount
      currency
      ocrCurrency
      type
      status
      currentPage
      prevPage
      archivedDate
      category
      ocrCategory
      note
      ocrNote
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poId
      quoteId
      supplierId
      costlineId
      projectId
      ocrStatus
      vatAccount
      ocrData {
        bucket
        region
        key
        identityId
      }
      invoiceKey
      paymentMethods
      vatIntracom
      bankAccountNumber
      paymentReference
      paymentReferenceType
      bankAccountName
      supplierAccountingNumber
      supplierAccountingName
      projectNumber
      quoteNumber
      lastExportedDate
      preparePurchaseToPayDate
      fullPurchaseNumber
      bridgePaymentLinkId
      billitInboxItemId
      billitPeppolFileId
      billitSenderPeppolId
      billitImportDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListPreparePurchasesQueryVariables,
	APITypes.ListPreparePurchasesQuery
>
export const preparePurchaseByTenantId =
	/* GraphQL */ `query PreparePurchaseByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPreparePurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  preparePurchaseByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      uniqueTransactionId
      flag
      invoiceName
      ocrInvoiceName
      fileName
      ocrFileName
      invoiceDate
      ocrInvoiceDate
      paymentDate
      ocrPaymentDate
      paymentStatus
      preparePurchasePaidDate
      supplier
      ocrSupplier
      po
      ocrPO
      costlineName
      costlineName_fr
      projectName
      totalAmount
      taxAmount
      netAmountDetails {
        netAmount
        category
        projectId
        projectName
        projectNumber
        costlineId
        costlineName
        costlineName_fr
      }
      taxAmountDetails {
        taxAmount
        vatAccount
        vatIntracom
      }
      netAmount
      ocrTotalAmount
      ocrTaxAmount
      ocrNetAmount
      currency
      ocrCurrency
      type
      status
      currentPage
      prevPage
      archivedDate
      category
      ocrCategory
      note
      ocrNote
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poId
      quoteId
      supplierId
      costlineId
      projectId
      ocrStatus
      vatAccount
      ocrData {
        bucket
        region
        key
        identityId
      }
      invoiceKey
      paymentMethods
      vatIntracom
      bankAccountNumber
      paymentReference
      paymentReferenceType
      bankAccountName
      supplierAccountingNumber
      supplierAccountingName
      projectNumber
      quoteNumber
      lastExportedDate
      preparePurchaseToPayDate
      fullPurchaseNumber
      bridgePaymentLinkId
      billitInboxItemId
      billitPeppolFileId
      billitSenderPeppolId
      billitImportDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PreparePurchaseByTenantIdQueryVariables,
		APITypes.PreparePurchaseByTenantIdQuery
	>
export const preparePurchaseByTransactionId =
	/* GraphQL */ `query PreparePurchaseByTransactionId(
  $uniqueTransactionId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPreparePurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  preparePurchaseByTransactionId(
    uniqueTransactionId: $uniqueTransactionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      uniqueTransactionId
      flag
      invoiceName
      ocrInvoiceName
      fileName
      ocrFileName
      invoiceDate
      ocrInvoiceDate
      paymentDate
      ocrPaymentDate
      paymentStatus
      preparePurchasePaidDate
      supplier
      ocrSupplier
      po
      ocrPO
      costlineName
      costlineName_fr
      projectName
      totalAmount
      taxAmount
      netAmountDetails {
        netAmount
        category
        projectId
        projectName
        projectNumber
        costlineId
        costlineName
        costlineName_fr
      }
      taxAmountDetails {
        taxAmount
        vatAccount
        vatIntracom
      }
      netAmount
      ocrTotalAmount
      ocrTaxAmount
      ocrNetAmount
      currency
      ocrCurrency
      type
      status
      currentPage
      prevPage
      archivedDate
      category
      ocrCategory
      note
      ocrNote
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poId
      quoteId
      supplierId
      costlineId
      projectId
      ocrStatus
      vatAccount
      ocrData {
        bucket
        region
        key
        identityId
      }
      invoiceKey
      paymentMethods
      vatIntracom
      bankAccountNumber
      paymentReference
      paymentReferenceType
      bankAccountName
      supplierAccountingNumber
      supplierAccountingName
      projectNumber
      quoteNumber
      lastExportedDate
      preparePurchaseToPayDate
      fullPurchaseNumber
      bridgePaymentLinkId
      billitInboxItemId
      billitPeppolFileId
      billitSenderPeppolId
      billitImportDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PreparePurchaseByTransactionIdQueryVariables,
		APITypes.PreparePurchaseByTransactionIdQuery
	>
export const preparePurchaseByInvoiceKey =
	/* GraphQL */ `query PreparePurchaseByInvoiceKey(
  $invoiceKey: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPreparePurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  preparePurchaseByInvoiceKey(
    invoiceKey: $invoiceKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      uniqueTransactionId
      flag
      invoiceName
      ocrInvoiceName
      fileName
      ocrFileName
      invoiceDate
      ocrInvoiceDate
      paymentDate
      ocrPaymentDate
      paymentStatus
      preparePurchasePaidDate
      supplier
      ocrSupplier
      po
      ocrPO
      costlineName
      costlineName_fr
      projectName
      totalAmount
      taxAmount
      netAmountDetails {
        netAmount
        category
        projectId
        projectName
        projectNumber
        costlineId
        costlineName
        costlineName_fr
      }
      taxAmountDetails {
        taxAmount
        vatAccount
        vatIntracom
      }
      netAmount
      ocrTotalAmount
      ocrTaxAmount
      ocrNetAmount
      currency
      ocrCurrency
      type
      status
      currentPage
      prevPage
      archivedDate
      category
      ocrCategory
      note
      ocrNote
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poId
      quoteId
      supplierId
      costlineId
      projectId
      ocrStatus
      vatAccount
      ocrData {
        bucket
        region
        key
        identityId
      }
      invoiceKey
      paymentMethods
      vatIntracom
      bankAccountNumber
      paymentReference
      paymentReferenceType
      bankAccountName
      supplierAccountingNumber
      supplierAccountingName
      projectNumber
      quoteNumber
      lastExportedDate
      preparePurchaseToPayDate
      fullPurchaseNumber
      bridgePaymentLinkId
      billitInboxItemId
      billitPeppolFileId
      billitSenderPeppolId
      billitImportDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PreparePurchaseByInvoiceKeyQueryVariables,
		APITypes.PreparePurchaseByInvoiceKeyQuery
	>
export const preparePurchaseByBridgePaymentLinkId =
	/* GraphQL */ `query PreparePurchaseByBridgePaymentLinkId(
  $bridgePaymentLinkId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPreparePurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  preparePurchaseByBridgePaymentLinkId(
    bridgePaymentLinkId: $bridgePaymentLinkId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      uniqueTransactionId
      flag
      invoiceName
      ocrInvoiceName
      fileName
      ocrFileName
      invoiceDate
      ocrInvoiceDate
      paymentDate
      ocrPaymentDate
      paymentStatus
      preparePurchasePaidDate
      supplier
      ocrSupplier
      po
      ocrPO
      costlineName
      costlineName_fr
      projectName
      totalAmount
      taxAmount
      netAmountDetails {
        netAmount
        category
        projectId
        projectName
        projectNumber
        costlineId
        costlineName
        costlineName_fr
      }
      taxAmountDetails {
        taxAmount
        vatAccount
        vatIntracom
      }
      netAmount
      ocrTotalAmount
      ocrTaxAmount
      ocrNetAmount
      currency
      ocrCurrency
      type
      status
      currentPage
      prevPage
      archivedDate
      category
      ocrCategory
      note
      ocrNote
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poId
      quoteId
      supplierId
      costlineId
      projectId
      ocrStatus
      vatAccount
      ocrData {
        bucket
        region
        key
        identityId
      }
      invoiceKey
      paymentMethods
      vatIntracom
      bankAccountNumber
      paymentReference
      paymentReferenceType
      bankAccountName
      supplierAccountingNumber
      supplierAccountingName
      projectNumber
      quoteNumber
      lastExportedDate
      preparePurchaseToPayDate
      fullPurchaseNumber
      bridgePaymentLinkId
      billitInboxItemId
      billitPeppolFileId
      billitSenderPeppolId
      billitImportDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PreparePurchaseByBridgePaymentLinkIdQueryVariables,
		APITypes.PreparePurchaseByBridgePaymentLinkIdQuery
	>
export const preparePurchaseByBillitInboxItemId =
	/* GraphQL */ `query PreparePurchaseByBillitInboxItemId(
  $billitInboxItemId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPreparePurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  preparePurchaseByBillitInboxItemId(
    billitInboxItemId: $billitInboxItemId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      uniqueTransactionId
      flag
      invoiceName
      ocrInvoiceName
      fileName
      ocrFileName
      invoiceDate
      ocrInvoiceDate
      paymentDate
      ocrPaymentDate
      paymentStatus
      preparePurchasePaidDate
      supplier
      ocrSupplier
      po
      ocrPO
      costlineName
      costlineName_fr
      projectName
      totalAmount
      taxAmount
      netAmountDetails {
        netAmount
        category
        projectId
        projectName
        projectNumber
        costlineId
        costlineName
        costlineName_fr
      }
      taxAmountDetails {
        taxAmount
        vatAccount
        vatIntracom
      }
      netAmount
      ocrTotalAmount
      ocrTaxAmount
      ocrNetAmount
      currency
      ocrCurrency
      type
      status
      currentPage
      prevPage
      archivedDate
      category
      ocrCategory
      note
      ocrNote
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poId
      quoteId
      supplierId
      costlineId
      projectId
      ocrStatus
      vatAccount
      ocrData {
        bucket
        region
        key
        identityId
      }
      invoiceKey
      paymentMethods
      vatIntracom
      bankAccountNumber
      paymentReference
      paymentReferenceType
      bankAccountName
      supplierAccountingNumber
      supplierAccountingName
      projectNumber
      quoteNumber
      lastExportedDate
      preparePurchaseToPayDate
      fullPurchaseNumber
      bridgePaymentLinkId
      billitInboxItemId
      billitPeppolFileId
      billitSenderPeppolId
      billitImportDate
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PreparePurchaseByBillitInboxItemIdQueryVariables,
		APITypes.PreparePurchaseByBillitInboxItemIdQuery
	>
export const getProjects = /* GraphQL */ `query GetProjects($id: ID!) {
  getProjects(id: $id) {
    id
    name
    tenantId
    freelancers
    childFreelancers
    offlineIds
    parentProjectId
    parentClientId
    activeFlag
    type
    parentTeamId
    parentSubTeamId
    isSubTeam
    projectType
    projectGroup
    parentCompanyId
    projectNumber
    subTeamCount
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<
	APITypes.GetProjectsQueryVariables,
	APITypes.GetProjectsQuery
>
export const listProjects = /* GraphQL */ `query ListProjects(
  $filter: ModelProjectsFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      parentTeamId
      parentSubTeamId
      isSubTeam
      projectType
      projectGroup
      parentCompanyId
      projectNumber
      subTeamCount
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListProjectsQueryVariables,
	APITypes.ListProjectsQuery
>
export const projectsByTenantId = /* GraphQL */ `query ProjectsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectsFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      parentTeamId
      parentSubTeamId
      isSubTeam
      projectType
      projectGroup
      parentCompanyId
      projectNumber
      subTeamCount
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ProjectsByTenantIdQueryVariables,
	APITypes.ProjectsByTenantIdQuery
>
export const projectsByParentProjectId =
	/* GraphQL */ `query ProjectsByParentProjectId(
  $parentProjectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectsFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByParentProjectId(
    parentProjectId: $parentProjectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      parentTeamId
      parentSubTeamId
      isSubTeam
      projectType
      projectGroup
      parentCompanyId
      projectNumber
      subTeamCount
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ProjectsByParentProjectIdQueryVariables,
		APITypes.ProjectsByParentProjectIdQuery
	>
export const projectsByClientId = /* GraphQL */ `query ProjectsByClientId(
  $parentClientId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectsFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByClientId(
    parentClientId: $parentClientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      tenantId
      freelancers
      childFreelancers
      offlineIds
      parentProjectId
      parentClientId
      activeFlag
      type
      parentTeamId
      parentSubTeamId
      isSubTeam
      projectType
      projectGroup
      parentCompanyId
      projectNumber
      subTeamCount
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ProjectsByClientIdQueryVariables,
	APITypes.ProjectsByClientIdQuery
>
export const getProposals = /* GraphQL */ `query GetProposals($id: ID!) {
  getProposals(id: $id) {
    id
    tenantId
    activeFlag
    quoteId
    quoteType
    clientId
    contactId
    status
    noofInvoices
    quoteName
    quoteNumber
    projectName
    projectNumber
    clientTaxType
    clientName
    contactName
    clientEmail
    clientAddress
    clientCountry
    clientIdNumber
    clientVatNumber
    clientCurrency
    clientTaxRate
    paymentTerms
    total
    clientNote
    isDetailed
    isClientTaxRate
    bankProfileNumber
    proposalsBankProfileName
    proposalsBank
    proposalsIban
    proposalsBic
    proposalsAccountName
    drafts {
      generated
      poNumber
      proposalAmountPercentage
      amount
      amountAfterTax
      taxAmount
      balancePercentage
      balanceAmount
      invoiceId
      invoiceDate
      invoiceDueDate
      description
      readyStatus
      taxDetails {
        taxRate
        taxPercentage
        taxAmount
        taxableAmount
      }
      salesAccNumberType
      sectionDetails {
        type
        amount
      }
      sectionDetailsByQuote {
        type
        amount
      }
      sectionDetailsByAccSection {
        type
        amount
      }
    }
    quote {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    invoices {
      items {
        id
        tenantId
        proposalId
        quoteType
        activeFlag
        originalInvoiceId
        creditInvoiceGenerated
        archivedDate
        paidDate
        paymentStatus
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientId
        contactId
        clientName
        contactName
        clientTaxType
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        title
        invoiceNumber
        poNumber
        invoiceAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        invoicesBankProfileName
        invoicesBank
        invoicesIban
        invoicesBic
        invoicesAccountName
        invoiceDate
        invoiceDueDate
        description
        creditComments
        invoiceType
        proposalsDraft {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
        proposals {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        createdOn
        updatedOn
        uniqueTransactionId
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        lastExportedDate
        emailSent
        draftEmailData {
          toEmail
          toCC
          toBCC
          subject
          body
          template
        }
        emailHistory {
          date
          subject
        }
        billitInboxItemId
        billitPeppolStatus
        billitPeppolError
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    poDate
    poName
    poAmount
    poCurrency
    poNotes
    poDocuments {
      bucket
      region
      key
      identityId
    }
    poVersion
    prevStatus
    assignedTenantId
    assignedTenantName
    showBidLetter
    companyLogo
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<
	APITypes.GetProposalsQueryVariables,
	APITypes.GetProposalsQuery
>
export const listProposals = /* GraphQL */ `query ListProposals(
  $filter: ModelProposalsFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListProposalsQueryVariables,
	APITypes.ListProposalsQuery
>
export const proposalsByTenantId = /* GraphQL */ `query ProposalsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProposalsFilterInput
  $limit: Int
  $nextToken: String
) {
  proposalsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ProposalsByTenantIdQueryVariables,
	APITypes.ProposalsByTenantIdQuery
>
export const proposalsByQuoteId = /* GraphQL */ `query ProposalsByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProposalsFilterInput
  $limit: Int
  $nextToken: String
) {
  proposalsByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ProposalsByQuoteIdQueryVariables,
	APITypes.ProposalsByQuoteIdQuery
>
export const proposalsByAssignedTenantId =
	/* GraphQL */ `query ProposalsByAssignedTenantId(
  $assignedTenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProposalsFilterInput
  $limit: Int
  $nextToken: String
) {
  proposalsByAssignedTenantId(
    assignedTenantId: $assignedTenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      quoteType
      clientId
      contactId
      status
      noofInvoices
      quoteName
      quoteNumber
      projectName
      projectNumber
      clientTaxType
      clientName
      contactName
      clientEmail
      clientAddress
      clientCountry
      clientIdNumber
      clientVatNumber
      clientCurrency
      clientTaxRate
      paymentTerms
      total
      clientNote
      isDetailed
      isClientTaxRate
      bankProfileNumber
      proposalsBankProfileName
      proposalsBank
      proposalsIban
      proposalsBic
      proposalsAccountName
      drafts {
        generated
        poNumber
        proposalAmountPercentage
        amount
        amountAfterTax
        taxAmount
        balancePercentage
        balanceAmount
        invoiceId
        invoiceDate
        invoiceDueDate
        description
        readyStatus
        taxDetails {
          taxRate
          taxPercentage
          taxAmount
          taxableAmount
        }
        salesAccNumberType
        sectionDetails {
          type
          amount
        }
        sectionDetailsByQuote {
          type
          amount
        }
        sectionDetailsByAccSection {
          type
          amount
        }
      }
      quote {
        id
        name
        tenantId
        quoteType
        quoteVersion
        aiGenerationRunId
        aiGenerationStatus
        aiGenerationError
        aiGenerationStartedAt
        aiGenerationCompletedAt
        aiGeneratedByUserId
        blankQuoteType
        parentTeamId
        parentSubTeamId
        visibility
        quoteLanguage
        childFreelancers
        offlineIds
        activeFlag
        type
        mergedQuotes
        parentProjectId
        billLocation
        marginLabel
        overheadLabel
        marginAndOverheadLabel
        marginPercentage
        overheadPercentage
        exchangeRate
        localExchangeRate
        localOtNumberOfHours
        exeOtNumberOfHours
        marginVAT_rate
        marginAcc_section
        allowInternational
        freelancers
        parentCompanyId
        companyLogo
        maximizeMinimize
        provisionalColumn
        selectContactById
        clientId
        contactId
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        conclusion
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        isFinalized
        recapInfoComments
        contact
        quoteTotal {
          budgetSubTotal
          budgetGrandTotal
          budgetMargin
          budgetMarginPercentage
          budgetSeperateMargin
          budgetSeperateMarginPercentage
          budgetSeperateOverhead
          budgetSeperateOverheadPercentage
          provisionalSubTotal
          provisionalGrandTotal
          provisionalMargin
          provisionalMarginPercentage
          actualSubTotal
          actualGrandTotal
          actualMargin
          actualMarginPercentage
          purchaseSubTotal
          purchaseGrandTotal
          purchaseMargin
          purchaseMarginPercentage
          grandBudgetWithMarginTotal
          noMarginTotalPercentage
          subTotalBudgetWithMargin
          subTotalBudgetWithoutMargin
          subTotalBudgetWithMarginPercentage
        }
        quoteTotalDiscount {
          totalAfterDiscount
          totalDiscount
          budgetTotalDiscountOnMargin
          budgetTotalDiscountOnMarginPercentage
          budgetTotalDiscountPercentage
          provisionalTotalDiscountOnMargin
          provisionalTotalDiscountOnMarginPercentage
          provisionalTotalDiscountPercentage
          actualTotalDiscountOnMargin
          actualTotalDiscountOnMarginPercentage
          actualTotalDiscountPercentage
          purchaseTotalDiscountOnMargin
          purchaseTotalDiscountOnMarginPercentage
          purchaseTotalDiscountPercentage
        }
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        quoteNumber
        quoteAccountingCategory
        deliveryDate
        quoteTertiaryCategory
        exeLocation
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        description
        service
        scope
        vhr
        billingAddress
        dateOfShoot
        photographer
        jobNumber
        photoLocation
        quoteProdValue1
        quoteProdValue2
        quoteProdValue3
        quoteProdValue4
        quoteProdValue5
        quoteProdValue6
        quoteProdValue7
        quoteProdValue8
        quoteProdValue9
        quoteProdValue10
        quoteProdValue11
        quoteProdValue12
        quoteProdValue13
        quoteProdValue14
        quoteProdValue15
        quoteProdValue16
        quoteProdValue17
        quoteProdValue18
        quoteProdValue19
        quoteProdValue20
        quoteProdValue21
        quoteProdValue22
        quoteProdValue23
        quoteProdValue24
        quoteProdValue25
        termsType
        termsSelection
        quoteCurrency
        exeQuoteCurrency
        marginCustomization
        pdfColumnCustomization
        pdfMiscCustomization
        summaryTableCustomization
        quoteHeaderLabel1
        quoteHeaderValue1
        quoteHeaderLabel2
        quoteHeaderValue2
        quoteHeaderLabel3
        quoteHeaderValue3
        quoteHeaderLabel4
        quoteHeaderValue4
        quoteHeaderLabel5
        quoteHeaderValue5
        quoteHeaderLabel6
        quoteHeaderValue6
        quoteHeaderLabel7
        quoteHeaderValue7
        quoteHeaderLabel8
        quoteHeaderValue8
        quoteHeaderLabel9
        quoteHeaderValue9
        quoteHeaderLabel10
        quoteHeaderValue10
        quoteHeaderLabel11
        quoteHeaderValue11
        productionNoteLabels
        budgetSections
        showCo2InSummary
        showCo2InPdf
        numberOfPrepDaysCo2
        numberOfShootDaysCo2
        numberOfPeopleOnSetCo2
        enableTravelCo2
        travelTypeCo2
        percentageOfCrewTravelCo2
        travelTypeLocation2Co2
        percentageOfCrewTravelLocation2Co2
        overtimeHours1Rate
        overtimeHours2Rate
        overtimeHours3Rate
        overtimeHours4Rate
        assignedTenantId
        assignedTenantName
        isExpired
        filledCostlineDetails {
          totalBudget
          totalCrewBudget
          totalPostProdBudget
          crewPrepNumberOfDays
          crewShootNumberOfDays
        }
        proposals {
          nextToken
        }
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      invoices {
        items {
          id
          tenantId
          proposalId
          quoteType
          activeFlag
          originalInvoiceId
          creditInvoiceGenerated
          archivedDate
          paidDate
          paymentStatus
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientId
          contactId
          clientName
          contactName
          clientTaxType
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          title
          invoiceNumber
          poNumber
          invoiceAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          invoicesBankProfileName
          invoicesBank
          invoicesIban
          invoicesBic
          invoicesAccountName
          invoiceDate
          invoiceDueDate
          description
          creditComments
          invoiceType
          salesAccNumberType
          createdOn
          updatedOn
          uniqueTransactionId
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          lastExportedDate
          emailSent
          billitInboxItemId
          billitPeppolStatus
          billitPeppolError
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      poDate
      poName
      poAmount
      poCurrency
      poNotes
      poDocuments {
        bucket
        region
        key
        identityId
      }
      poVersion
      prevStatus
      assignedTenantId
      assignedTenantName
      showBidLetter
      companyLogo
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ProposalsByAssignedTenantIdQueryVariables,
		APITypes.ProposalsByAssignedTenantIdQuery
	>
export const getPurchase = /* GraphQL */ `query GetPurchase($id: ID!) {
  getPurchase(id: $id) {
    id
    tenantId
    activeFlag
    quoteId
    supplierId
    recapCostlineId
    quoteName
    projectName
    supplierName
    recapCostlineItem
    recapCostlineItem_fr
    currency
    provisionalTotal
    invoiceTotal
    taxAmount
    purchaseInvoiceDueDate
    purchaseArchivedDate
    purchasePaidDate
    supplierCreditorAccount
    purchaseOrderId
    poAvailable
    invoiceAvailable
    paymentStatus
    purchaseType
    supplierType
    invoiceKey
    tags
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    quoteNumber
    projectNumber
    invoiceNumber
    purchaseToPayDate
    purchaseNumber
    purchaseOrderNumber
    projectId
    supplierTerms
    quantity
    number
    rate
    taxRate
    deliveryDate
    deliveryAddress
    poComments
    poGenerated
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<
	APITypes.GetPurchaseQueryVariables,
	APITypes.GetPurchaseQuery
>
export const listPurchases = /* GraphQL */ `query ListPurchases(
  $filter: ModelPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listPurchases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      currency
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      tags
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      quoteNumber
      projectNumber
      invoiceNumber
      purchaseToPayDate
      purchaseNumber
      purchaseOrderNumber
      projectId
      supplierTerms
      quantity
      number
      rate
      taxRate
      deliveryDate
      deliveryAddress
      poComments
      poGenerated
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListPurchasesQueryVariables,
	APITypes.ListPurchasesQuery
>
export const purchasesByTenantId = /* GraphQL */ `query PurchasesByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  purchasesByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      currency
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      tags
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      quoteNumber
      projectNumber
      invoiceNumber
      purchaseToPayDate
      purchaseNumber
      purchaseOrderNumber
      projectId
      supplierTerms
      quantity
      number
      rate
      taxRate
      deliveryDate
      deliveryAddress
      poComments
      poGenerated
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.PurchasesByTenantIdQueryVariables,
	APITypes.PurchasesByTenantIdQuery
>
export const purchasesBySupplierId = /* GraphQL */ `query PurchasesBySupplierId(
  $supplierId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  purchasesBySupplierId(
    supplierId: $supplierId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      currency
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      tags
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      quoteNumber
      projectNumber
      invoiceNumber
      purchaseToPayDate
      purchaseNumber
      purchaseOrderNumber
      projectId
      supplierTerms
      quantity
      number
      rate
      taxRate
      deliveryDate
      deliveryAddress
      poComments
      poGenerated
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.PurchasesBySupplierIdQueryVariables,
	APITypes.PurchasesBySupplierIdQuery
>
export const purchasesByRecapCostlineId =
	/* GraphQL */ `query PurchasesByRecapCostlineId(
  $recapCostlineId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  purchasesByRecapCostlineId(
    recapCostlineId: $recapCostlineId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      currency
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      tags
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      quoteNumber
      projectNumber
      invoiceNumber
      purchaseToPayDate
      purchaseNumber
      purchaseOrderNumber
      projectId
      supplierTerms
      quantity
      number
      rate
      taxRate
      deliveryDate
      deliveryAddress
      poComments
      poGenerated
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PurchasesByRecapCostlineIdQueryVariables,
		APITypes.PurchasesByRecapCostlineIdQuery
	>
export const purchaseByInvoiceKey = /* GraphQL */ `query PurchaseByInvoiceKey(
  $invoiceKey: String!
  $sortDirection: ModelSortDirection
  $filter: ModelPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  purchaseByInvoiceKey(
    invoiceKey: $invoiceKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      quoteId
      supplierId
      recapCostlineId
      quoteName
      projectName
      supplierName
      recapCostlineItem
      recapCostlineItem_fr
      currency
      provisionalTotal
      invoiceTotal
      taxAmount
      purchaseInvoiceDueDate
      purchaseArchivedDate
      purchasePaidDate
      supplierCreditorAccount
      purchaseOrderId
      poAvailable
      invoiceAvailable
      paymentStatus
      purchaseType
      supplierType
      invoiceKey
      tags
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      quoteNumber
      projectNumber
      invoiceNumber
      purchaseToPayDate
      purchaseNumber
      purchaseOrderNumber
      projectId
      supplierTerms
      quantity
      number
      rate
      taxRate
      deliveryDate
      deliveryAddress
      poComments
      poGenerated
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.PurchaseByInvoiceKeyQueryVariables,
	APITypes.PurchaseByInvoiceKeyQuery
>
export const getPurchaseOrder =
	/* GraphQL */ `query GetPurchaseOrder($id: ID!) {
  getPurchaseOrder(id: $id) {
    id
    tenantId
    activeFlag
    purchaseOrderNumber
    quoteId
    supplierId
    recapCostlineId
    costlineName
    costlineName_fr
    projectId
    quoteNumber
    poAvailable
    supplierName
    supplierTerms
    quantity
    number
    rate
    provisionalTotal
    taxRate
    deliveryDate
    deliveryAddress
    comments
    status
    generated
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedQuery<
		APITypes.GetPurchaseOrderQueryVariables,
		APITypes.GetPurchaseOrderQuery
	>
export const listPurchaseOrders = /* GraphQL */ `query ListPurchaseOrders(
  $filter: ModelPurchaseOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listPurchaseOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      purchaseOrderNumber
      quoteId
      supplierId
      recapCostlineId
      costlineName
      costlineName_fr
      projectId
      quoteNumber
      poAvailable
      supplierName
      supplierTerms
      quantity
      number
      rate
      provisionalTotal
      taxRate
      deliveryDate
      deliveryAddress
      comments
      status
      generated
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListPurchaseOrdersQueryVariables,
	APITypes.ListPurchaseOrdersQuery
>
export const purchaseOrdersByTenantId =
	/* GraphQL */ `query PurchaseOrdersByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPurchaseOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  purchaseOrdersByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      purchaseOrderNumber
      quoteId
      supplierId
      recapCostlineId
      costlineName
      costlineName_fr
      projectId
      quoteNumber
      poAvailable
      supplierName
      supplierTerms
      quantity
      number
      rate
      provisionalTotal
      taxRate
      deliveryDate
      deliveryAddress
      comments
      status
      generated
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.PurchaseOrdersByTenantIdQueryVariables,
		APITypes.PurchaseOrdersByTenantIdQuery
	>
export const getQuote = /* GraphQL */ `query GetQuote($id: ID!) {
  getQuote(id: $id) {
    id
    name
    tenantId
    quoteType
    quoteVersion
    aiGenerationRunId
    aiGenerationStatus
    aiGenerationError
    aiGenerationStartedAt
    aiGenerationCompletedAt
    aiGeneratedByUserId
    blankQuoteType
    parentTeamId
    parentSubTeamId
    visibility
    quoteLanguage
    childFreelancers
    offlineIds
    activeFlag
    type
    mergedQuotes
    parentProjectId
    billLocation
    marginLabel
    overheadLabel
    marginAndOverheadLabel
    marginPercentage
    overheadPercentage
    exchangeRate
    localExchangeRate
    localOtNumberOfHours
    exeOtNumberOfHours
    marginVAT_rate
    marginAcc_section
    allowInternational
    freelancers
    parentCompanyId
    companyLogo
    maximizeMinimize
    provisionalColumn
    selectContactById
    clientId
    contactId
    clientName
    projectName
    agency
    agencyRepresentative
    director
    executiveProducer
    lineProducer
    numberOfShootingDays
    notes
    introduction
    shooting
    prep
    shootingCountry
    prelight
    casting
    crew
    buyouts
    locations
    studio
    artDepartment
    wardrobe
    equipment
    travel
    accommodation
    editing
    imagePostproduction
    soundPostproduction
    deliverables
    insurance
    quoteGuidelines
    excluded
    paymentTerms
    miscellaneous
    conclusion
    installment1Percentage
    installment1Date
    installment2Percentage
    installment2Date
    balancePercentage
    balanceDate
    isStarred
    isChecked
    isFinalized
    recapInfoComments
    contact
    quoteTotal {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    quoteTotalDiscount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
    discount {
      totalDiscount
      totalAfterDiscount
      totalDiscountOnMargin
      totalDiscountOnMarginPercentage
      totalDiscountPercentage
    }
    quoteNumber
    quoteAccountingCategory
    deliveryDate
    quoteTertiaryCategory
    exeLocation
    advertiserJobID
    brand
    jobName
    agencyJobID
    product
    advertiser
    productionJobID
    advertiserAddress
    productionCompany
    productionContact
    vfxCo
    vfxProducer
    editorialCo
    editorialProducer
    musicCo
    musicProducer
    agencyProducer
    agencyCreativeTeam
    prepDays
    buildAndStrikeDays
    preLight
    stageDays
    locationDays
    description
    service
    scope
    vhr
    billingAddress
    dateOfShoot
    photographer
    jobNumber
    photoLocation
    quoteProdValue1
    quoteProdValue2
    quoteProdValue3
    quoteProdValue4
    quoteProdValue5
    quoteProdValue6
    quoteProdValue7
    quoteProdValue8
    quoteProdValue9
    quoteProdValue10
    quoteProdValue11
    quoteProdValue12
    quoteProdValue13
    quoteProdValue14
    quoteProdValue15
    quoteProdValue16
    quoteProdValue17
    quoteProdValue18
    quoteProdValue19
    quoteProdValue20
    quoteProdValue21
    quoteProdValue22
    quoteProdValue23
    quoteProdValue24
    quoteProdValue25
    termsType
    termsSelection
    quoteCurrency
    exeQuoteCurrency
    marginCustomization
    pdfColumnCustomization
    pdfMiscCustomization
    summaryTableCustomization
    quoteHeaderLabel1
    quoteHeaderValue1
    quoteHeaderLabel2
    quoteHeaderValue2
    quoteHeaderLabel3
    quoteHeaderValue3
    quoteHeaderLabel4
    quoteHeaderValue4
    quoteHeaderLabel5
    quoteHeaderValue5
    quoteHeaderLabel6
    quoteHeaderValue6
    quoteHeaderLabel7
    quoteHeaderValue7
    quoteHeaderLabel8
    quoteHeaderValue8
    quoteHeaderLabel9
    quoteHeaderValue9
    quoteHeaderLabel10
    quoteHeaderValue10
    quoteHeaderLabel11
    quoteHeaderValue11
    productionNoteLabels
    budgetSections
    showCo2InSummary
    showCo2InPdf
    numberOfPrepDaysCo2
    numberOfShootDaysCo2
    numberOfPeopleOnSetCo2
    enableTravelCo2
    travelTypeCo2
    percentageOfCrewTravelCo2
    travelTypeLocation2Co2
    percentageOfCrewTravelLocation2Co2
    overtimeHours1Rate
    overtimeHours2Rate
    overtimeHours3Rate
    overtimeHours4Rate
    assignedTenantId
    assignedTenantName
    isExpired
    filledCostlineDetails {
      totalBudget
      totalCrewBudget
      totalPostProdBudget
      crewPrepNumberOfDays
      crewShootNumberOfDays
    }
    proposals {
      items {
        id
        tenantId
        activeFlag
        quoteId
        quoteType
        clientId
        contactId
        status
        noofInvoices
        quoteName
        quoteNumber
        projectName
        projectNumber
        clientTaxType
        clientName
        contactName
        clientEmail
        clientAddress
        clientCountry
        clientIdNumber
        clientVatNumber
        clientCurrency
        clientTaxRate
        paymentTerms
        total
        clientNote
        isDetailed
        isClientTaxRate
        bankProfileNumber
        proposalsBankProfileName
        proposalsBank
        proposalsIban
        proposalsBic
        proposalsAccountName
        drafts {
          generated
          poNumber
          proposalAmountPercentage
          amount
          amountAfterTax
          taxAmount
          balancePercentage
          balanceAmount
          invoiceId
          invoiceDate
          invoiceDueDate
          description
          readyStatus
          salesAccNumberType
        }
        quote {
          id
          name
          tenantId
          quoteType
          quoteVersion
          aiGenerationRunId
          aiGenerationStatus
          aiGenerationError
          aiGenerationStartedAt
          aiGenerationCompletedAt
          aiGeneratedByUserId
          blankQuoteType
          parentTeamId
          parentSubTeamId
          visibility
          quoteLanguage
          childFreelancers
          offlineIds
          activeFlag
          type
          mergedQuotes
          parentProjectId
          billLocation
          marginLabel
          overheadLabel
          marginAndOverheadLabel
          marginPercentage
          overheadPercentage
          exchangeRate
          localExchangeRate
          localOtNumberOfHours
          exeOtNumberOfHours
          marginVAT_rate
          marginAcc_section
          allowInternational
          freelancers
          parentCompanyId
          companyLogo
          maximizeMinimize
          provisionalColumn
          selectContactById
          clientId
          contactId
          clientName
          projectName
          agency
          agencyRepresentative
          director
          executiveProducer
          lineProducer
          numberOfShootingDays
          notes
          introduction
          shooting
          prep
          shootingCountry
          prelight
          casting
          crew
          buyouts
          locations
          studio
          artDepartment
          wardrobe
          equipment
          travel
          accommodation
          editing
          imagePostproduction
          soundPostproduction
          deliverables
          insurance
          quoteGuidelines
          excluded
          paymentTerms
          miscellaneous
          conclusion
          installment1Percentage
          installment1Date
          installment2Percentage
          installment2Date
          balancePercentage
          balanceDate
          isStarred
          isChecked
          isFinalized
          recapInfoComments
          contact
          quoteNumber
          quoteAccountingCategory
          deliveryDate
          quoteTertiaryCategory
          exeLocation
          advertiserJobID
          brand
          jobName
          agencyJobID
          product
          advertiser
          productionJobID
          advertiserAddress
          productionCompany
          productionContact
          vfxCo
          vfxProducer
          editorialCo
          editorialProducer
          musicCo
          musicProducer
          agencyProducer
          agencyCreativeTeam
          prepDays
          buildAndStrikeDays
          preLight
          stageDays
          locationDays
          description
          service
          scope
          vhr
          billingAddress
          dateOfShoot
          photographer
          jobNumber
          photoLocation
          quoteProdValue1
          quoteProdValue2
          quoteProdValue3
          quoteProdValue4
          quoteProdValue5
          quoteProdValue6
          quoteProdValue7
          quoteProdValue8
          quoteProdValue9
          quoteProdValue10
          quoteProdValue11
          quoteProdValue12
          quoteProdValue13
          quoteProdValue14
          quoteProdValue15
          quoteProdValue16
          quoteProdValue17
          quoteProdValue18
          quoteProdValue19
          quoteProdValue20
          quoteProdValue21
          quoteProdValue22
          quoteProdValue23
          quoteProdValue24
          quoteProdValue25
          termsType
          termsSelection
          quoteCurrency
          exeQuoteCurrency
          marginCustomization
          pdfColumnCustomization
          pdfMiscCustomization
          summaryTableCustomization
          quoteHeaderLabel1
          quoteHeaderValue1
          quoteHeaderLabel2
          quoteHeaderValue2
          quoteHeaderLabel3
          quoteHeaderValue3
          quoteHeaderLabel4
          quoteHeaderValue4
          quoteHeaderLabel5
          quoteHeaderValue5
          quoteHeaderLabel6
          quoteHeaderValue6
          quoteHeaderLabel7
          quoteHeaderValue7
          quoteHeaderLabel8
          quoteHeaderValue8
          quoteHeaderLabel9
          quoteHeaderValue9
          quoteHeaderLabel10
          quoteHeaderValue10
          quoteHeaderLabel11
          quoteHeaderValue11
          productionNoteLabels
          budgetSections
          showCo2InSummary
          showCo2InPdf
          numberOfPrepDaysCo2
          numberOfShootDaysCo2
          numberOfPeopleOnSetCo2
          enableTravelCo2
          travelTypeCo2
          percentageOfCrewTravelCo2
          travelTypeLocation2Co2
          percentageOfCrewTravelLocation2Co2
          overtimeHours1Rate
          overtimeHours2Rate
          overtimeHours3Rate
          overtimeHours4Rate
          assignedTenantId
          assignedTenantName
          isExpired
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        invoices {
          nextToken
        }
        createdOn
        updatedOn
        poDate
        poName
        poAmount
        poCurrency
        poNotes
        poDocuments {
          bucket
          region
          key
          identityId
        }
        poVersion
        prevStatus
        assignedTenantId
        assignedTenantName
        showBidLetter
        companyLogo
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    createdOn
    updatedOn
    _deleted
    _version
    _lastChangedAt
  }
}
` as GeneratedQuery<APITypes.GetQuoteQueryVariables, APITypes.GetQuoteQuery>
export const listQuotes = /* GraphQL */ `query ListQuotes(
  $filter: ModelQuoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<APITypes.ListQuotesQueryVariables, APITypes.ListQuotesQuery>
export const quotesByTenantId = /* GraphQL */ `query QuotesByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuoteFilterInput
  $limit: Int
  $nextToken: String
) {
  quotesByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.QuotesByTenantIdQueryVariables,
	APITypes.QuotesByTenantIdQuery
>
export const quotesByParentProjectId =
	/* GraphQL */ `query QuotesByParentProjectId(
  $parentProjectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuoteFilterInput
  $limit: Int
  $nextToken: String
) {
  quotesByParentProjectId(
    parentProjectId: $parentProjectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.QuotesByParentProjectIdQueryVariables,
		APITypes.QuotesByParentProjectIdQuery
	>
export const quotesByAssignedTenantId =
	/* GraphQL */ `query QuotesByAssignedTenantId(
  $assignedTenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuoteFilterInput
  $limit: Int
  $nextToken: String
) {
  quotesByAssignedTenantId(
    assignedTenantId: $assignedTenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      tenantId
      quoteType
      quoteVersion
      aiGenerationRunId
      aiGenerationStatus
      aiGenerationError
      aiGenerationStartedAt
      aiGenerationCompletedAt
      aiGeneratedByUserId
      blankQuoteType
      parentTeamId
      parentSubTeamId
      visibility
      quoteLanguage
      childFreelancers
      offlineIds
      activeFlag
      type
      mergedQuotes
      parentProjectId
      billLocation
      marginLabel
      overheadLabel
      marginAndOverheadLabel
      marginPercentage
      overheadPercentage
      exchangeRate
      localExchangeRate
      localOtNumberOfHours
      exeOtNumberOfHours
      marginVAT_rate
      marginAcc_section
      allowInternational
      freelancers
      parentCompanyId
      companyLogo
      maximizeMinimize
      provisionalColumn
      selectContactById
      clientId
      contactId
      clientName
      projectName
      agency
      agencyRepresentative
      director
      executiveProducer
      lineProducer
      numberOfShootingDays
      notes
      introduction
      shooting
      prep
      shootingCountry
      prelight
      casting
      crew
      buyouts
      locations
      studio
      artDepartment
      wardrobe
      equipment
      travel
      accommodation
      editing
      imagePostproduction
      soundPostproduction
      deliverables
      insurance
      quoteGuidelines
      excluded
      paymentTerms
      miscellaneous
      conclusion
      installment1Percentage
      installment1Date
      installment2Percentage
      installment2Date
      balancePercentage
      balanceDate
      isStarred
      isChecked
      isFinalized
      recapInfoComments
      contact
      quoteTotal {
        budgetSubTotal
        budgetGrandTotal
        budgetMargin
        budgetMarginPercentage
        budgetSeperateMargin
        budgetSeperateMarginPercentage
        budgetSeperateOverhead
        budgetSeperateOverheadPercentage
        provisionalSubTotal
        provisionalGrandTotal
        provisionalMargin
        provisionalMarginPercentage
        actualSubTotal
        actualGrandTotal
        actualMargin
        actualMarginPercentage
        purchaseSubTotal
        purchaseGrandTotal
        purchaseMargin
        purchaseMarginPercentage
        grandBudgetWithMarginTotal
        noMarginTotalPercentage
        subTotalBudgetWithMargin
        subTotalBudgetWithoutMargin
        subTotalBudgetWithMarginPercentage
      }
      quoteTotalDiscount {
        totalAfterDiscount
        totalDiscount
        budgetTotalDiscountOnMargin
        budgetTotalDiscountOnMarginPercentage
        budgetTotalDiscountPercentage
        provisionalTotalDiscountOnMargin
        provisionalTotalDiscountOnMarginPercentage
        provisionalTotalDiscountPercentage
        actualTotalDiscountOnMargin
        actualTotalDiscountOnMarginPercentage
        actualTotalDiscountPercentage
        purchaseTotalDiscountOnMargin
        purchaseTotalDiscountOnMarginPercentage
        purchaseTotalDiscountPercentage
      }
      discount {
        totalDiscount
        totalAfterDiscount
        totalDiscountOnMargin
        totalDiscountOnMarginPercentage
        totalDiscountPercentage
      }
      quoteNumber
      quoteAccountingCategory
      deliveryDate
      quoteTertiaryCategory
      exeLocation
      advertiserJobID
      brand
      jobName
      agencyJobID
      product
      advertiser
      productionJobID
      advertiserAddress
      productionCompany
      productionContact
      vfxCo
      vfxProducer
      editorialCo
      editorialProducer
      musicCo
      musicProducer
      agencyProducer
      agencyCreativeTeam
      prepDays
      buildAndStrikeDays
      preLight
      stageDays
      locationDays
      description
      service
      scope
      vhr
      billingAddress
      dateOfShoot
      photographer
      jobNumber
      photoLocation
      quoteProdValue1
      quoteProdValue2
      quoteProdValue3
      quoteProdValue4
      quoteProdValue5
      quoteProdValue6
      quoteProdValue7
      quoteProdValue8
      quoteProdValue9
      quoteProdValue10
      quoteProdValue11
      quoteProdValue12
      quoteProdValue13
      quoteProdValue14
      quoteProdValue15
      quoteProdValue16
      quoteProdValue17
      quoteProdValue18
      quoteProdValue19
      quoteProdValue20
      quoteProdValue21
      quoteProdValue22
      quoteProdValue23
      quoteProdValue24
      quoteProdValue25
      termsType
      termsSelection
      quoteCurrency
      exeQuoteCurrency
      marginCustomization
      pdfColumnCustomization
      pdfMiscCustomization
      summaryTableCustomization
      quoteHeaderLabel1
      quoteHeaderValue1
      quoteHeaderLabel2
      quoteHeaderValue2
      quoteHeaderLabel3
      quoteHeaderValue3
      quoteHeaderLabel4
      quoteHeaderValue4
      quoteHeaderLabel5
      quoteHeaderValue5
      quoteHeaderLabel6
      quoteHeaderValue6
      quoteHeaderLabel7
      quoteHeaderValue7
      quoteHeaderLabel8
      quoteHeaderValue8
      quoteHeaderLabel9
      quoteHeaderValue9
      quoteHeaderLabel10
      quoteHeaderValue10
      quoteHeaderLabel11
      quoteHeaderValue11
      productionNoteLabels
      budgetSections
      showCo2InSummary
      showCo2InPdf
      numberOfPrepDaysCo2
      numberOfShootDaysCo2
      numberOfPeopleOnSetCo2
      enableTravelCo2
      travelTypeCo2
      percentageOfCrewTravelCo2
      travelTypeLocation2Co2
      percentageOfCrewTravelLocation2Co2
      overtimeHours1Rate
      overtimeHours2Rate
      overtimeHours3Rate
      overtimeHours4Rate
      assignedTenantId
      assignedTenantName
      isExpired
      filledCostlineDetails {
        totalBudget
        totalCrewBudget
        totalPostProdBudget
        crewPrepNumberOfDays
        crewShootNumberOfDays
      }
      proposals {
        items {
          id
          tenantId
          activeFlag
          quoteId
          quoteType
          clientId
          contactId
          status
          noofInvoices
          quoteName
          quoteNumber
          projectName
          projectNumber
          clientTaxType
          clientName
          contactName
          clientEmail
          clientAddress
          clientCountry
          clientIdNumber
          clientVatNumber
          clientCurrency
          clientTaxRate
          paymentTerms
          total
          clientNote
          isDetailed
          isClientTaxRate
          bankProfileNumber
          proposalsBankProfileName
          proposalsBank
          proposalsIban
          proposalsBic
          proposalsAccountName
          createdOn
          updatedOn
          poDate
          poName
          poAmount
          poCurrency
          poNotes
          poVersion
          prevStatus
          assignedTenantId
          assignedTenantName
          showBidLetter
          companyLogo
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      createdOn
      updatedOn
      _deleted
      _version
      _lastChangedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.QuotesByAssignedTenantIdQueryVariables,
		APITypes.QuotesByAssignedTenantIdQuery
	>
export const getQuoteInfo = /* GraphQL */ `query GetQuoteInfo($id: ID!) {
  getQuoteInfo(id: $id) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    agentCommission
    agentCommissionPercentage
    allowMarginAndOverheadPercentageGlobalUpdate
    language
    costlineUuid
    category
    categoryId
    categoryPrefix
    category_fr
    categoryUuid
    categoryLabelValue
    costLineLabel
    costLineEditLabel
    costLineType
    costLineCurrency
    editable
    exchangeEnabled
    exchangeRate
    tableRowIndex
    fractionalSortKey
    isInternational
    isVisible
    item
    item_fr
    margin
    marginPercentage
    number
    shootNumber
    overhead
    overheadPercentage
    discountPercentage
    overtimeDetails {
      multiplier
      overtimeHours
    }
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    overtimeHours
    otNumberOfHours
    overtimeHoursCost
    payrollTaxEnabled
    payrollTaxType
    quantity
    rate
    rateInEuros
    rowColor
    costlineHeader
    subCategory
    subCategoryId
    subCategoryPrefix
    subCategorySuffix
    subCategory_fr
    subCategoryUuid
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    total
    totalHeading
    totalMargin
    unit
    smg
    VAT_rate
    Acc_section
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
	APITypes.GetQuoteInfoQueryVariables,
	APITypes.GetQuoteInfoQuery
>
export const listQuoteInfos = /* GraphQL */ `query ListQuoteInfos(
  $filter: ModelQuoteInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuoteInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      costlineUuid
      category
      categoryId
      categoryPrefix
      category_fr
      categoryUuid
      categoryLabelValue
      costLineLabel
      costLineEditLabel
      costLineType
      costLineCurrency
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      fractionalSortKey
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      shootNumber
      overhead
      overheadPercentage
      discountPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      overtimeHours
      otNumberOfHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      rowColor
      costlineHeader
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      subCategoryUuid
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      total
      totalHeading
      totalMargin
      unit
      smg
      VAT_rate
      Acc_section
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListQuoteInfosQueryVariables,
	APITypes.ListQuoteInfosQuery
>
export const quoteInfoByQuoteId = /* GraphQL */ `query QuoteInfoByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuoteInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  quoteInfoByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      costlineUuid
      category
      categoryId
      categoryPrefix
      category_fr
      categoryUuid
      categoryLabelValue
      costLineLabel
      costLineEditLabel
      costLineType
      costLineCurrency
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      fractionalSortKey
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      shootNumber
      overhead
      overheadPercentage
      discountPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      overtimeHours
      otNumberOfHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      rowColor
      costlineHeader
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      subCategoryUuid
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      total
      totalHeading
      totalMargin
      unit
      smg
      VAT_rate
      Acc_section
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.QuoteInfoByQuoteIdQueryVariables,
	APITypes.QuoteInfoByQuoteIdQuery
>
export const quoteInfoByTenantId = /* GraphQL */ `query QuoteInfoByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelQuoteInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  quoteInfoByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      agentCommission
      agentCommissionPercentage
      allowMarginAndOverheadPercentageGlobalUpdate
      language
      costlineUuid
      category
      categoryId
      categoryPrefix
      category_fr
      categoryUuid
      categoryLabelValue
      costLineLabel
      costLineEditLabel
      costLineType
      costLineCurrency
      editable
      exchangeEnabled
      exchangeRate
      tableRowIndex
      fractionalSortKey
      isInternational
      isVisible
      item
      item_fr
      margin
      marginPercentage
      number
      shootNumber
      overhead
      overheadPercentage
      discountPercentage
      overtimeDetails {
        multiplier
        overtimeHours
      }
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      overtimeHours
      otNumberOfHours
      overtimeHoursCost
      payrollTaxEnabled
      payrollTaxType
      quantity
      rate
      rateInEuros
      rowColor
      costlineHeader
      subCategory
      subCategoryId
      subCategoryPrefix
      subCategorySuffix
      subCategory_fr
      subCategoryUuid
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      total
      totalHeading
      totalMargin
      unit
      smg
      VAT_rate
      Acc_section
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.QuoteInfoByTenantIdQueryVariables,
	APITypes.QuoteInfoByTenantIdQuery
>
export const getRecapInfo = /* GraphQL */ `query GetRecapInfo($id: ID!) {
  getRecapInfo(id: $id) {
    id
    quoteId
    tenantId
    originalQuoteId
    freelancers
    childFreelancers
    offlineIds
    activeFlag
    uuid
    costlineUuid
    categoryId
    categoryUuid
    category
    category_fr
    categoryPrefix
    categoryLabelValue
    subCategoryId
    subCategoryUuid
    subCategory
    subCategory_fr
    subCategoryPrefix
    subCategorySuffix
    subCategoryLabelValue
    thirdLevelSection
    thirdLevelSectionId
    thirdLevelSectionPrefix
    thirdLevelSection_fr
    thirdLevelSectionUuid
    thirdLevelSectionLabelValue
    tableRowIndex
    fractionalSortKey
    item
    item_fr
    isInternational
    editable
    costLineType
    costLineLabel
    costLineEditLabel
    language
    number
    shootNumber
    rate
    exchangeEnabled
    exchangeRate
    rateInEuros
    quantity
    total
    totalMargin
    payrollTaxEnabled
    payrollTaxType
    overtimeHours1
    overtimeHours2
    overtimeHours3
    overtimeHours4
    otNumberOfHours
    overtimeHoursCost
    isCustomCostLine
    referenceCostLineUuid
    provisionalQuantity
    provisionalNumber
    provisionalShootNumber
    provisionalRate
    provisionalOtTotal
    provisionalTotal
    provisionalPayrollTaxEnabled
    provisionalPayrollTaxType
    actualTotal
    actualPayrollTaxEnabled
    actualPayrollTaxType
    purchaseTotal
    supplierStatus
    supplierId
    paymentStatus
    purchaseId
    comments
    invoiceId
    invoiceAvailable
    invoiceDocuments {
      bucket
      region
      key
      identityId
    }
    poAvailable
    purchaseOrderId
    rowColor
    costlineHeader
    startDate
    endDate
    days
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
	APITypes.GetRecapInfoQueryVariables,
	APITypes.GetRecapInfoQuery
>
export const listRecapInfos = /* GraphQL */ `query ListRecapInfos(
  $filter: ModelRecapInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecapInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      costlineUuid
      categoryId
      categoryUuid
      category
      category_fr
      categoryPrefix
      categoryLabelValue
      subCategoryId
      subCategoryUuid
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      tableRowIndex
      fractionalSortKey
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      costLineEditLabel
      language
      number
      shootNumber
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      otNumberOfHours
      overtimeHoursCost
      isCustomCostLine
      referenceCostLineUuid
      provisionalQuantity
      provisionalNumber
      provisionalShootNumber
      provisionalRate
      provisionalOtTotal
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      rowColor
      costlineHeader
      startDate
      endDate
      days
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListRecapInfosQueryVariables,
	APITypes.ListRecapInfosQuery
>
export const recapInfoInfoByQuoteId =
	/* GraphQL */ `query RecapInfoInfoByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecapInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  recapInfoInfoByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      costlineUuid
      categoryId
      categoryUuid
      category
      category_fr
      categoryPrefix
      categoryLabelValue
      subCategoryId
      subCategoryUuid
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      tableRowIndex
      fractionalSortKey
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      costLineEditLabel
      language
      number
      shootNumber
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      otNumberOfHours
      overtimeHoursCost
      isCustomCostLine
      referenceCostLineUuid
      provisionalQuantity
      provisionalNumber
      provisionalShootNumber
      provisionalRate
      provisionalOtTotal
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      rowColor
      costlineHeader
      startDate
      endDate
      days
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.RecapInfoInfoByQuoteIdQueryVariables,
		APITypes.RecapInfoInfoByQuoteIdQuery
	>
export const recapQuoteInfoByTenantId =
	/* GraphQL */ `query RecapQuoteInfoByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecapInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  recapQuoteInfoByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      costlineUuid
      categoryId
      categoryUuid
      category
      category_fr
      categoryPrefix
      categoryLabelValue
      subCategoryId
      subCategoryUuid
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      tableRowIndex
      fractionalSortKey
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      costLineEditLabel
      language
      number
      shootNumber
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      otNumberOfHours
      overtimeHoursCost
      isCustomCostLine
      referenceCostLineUuid
      provisionalQuantity
      provisionalNumber
      provisionalShootNumber
      provisionalRate
      provisionalOtTotal
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      rowColor
      costlineHeader
      startDate
      endDate
      days
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.RecapQuoteInfoByTenantIdQueryVariables,
		APITypes.RecapQuoteInfoByTenantIdQuery
	>
export const recapQuoteInfoByTenantIdWithSortDays =
	/* GraphQL */ `query RecapQuoteInfoByTenantIdWithSortDays(
  $tenantId: ID!
  $days: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRecapInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  recapQuoteInfoByTenantIdWithSortDays(
    tenantId: $tenantId
    days: $days
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      originalQuoteId
      freelancers
      childFreelancers
      offlineIds
      activeFlag
      uuid
      costlineUuid
      categoryId
      categoryUuid
      category
      category_fr
      categoryPrefix
      categoryLabelValue
      subCategoryId
      subCategoryUuid
      subCategory
      subCategory_fr
      subCategoryPrefix
      subCategorySuffix
      subCategoryLabelValue
      thirdLevelSection
      thirdLevelSectionId
      thirdLevelSectionPrefix
      thirdLevelSection_fr
      thirdLevelSectionUuid
      thirdLevelSectionLabelValue
      tableRowIndex
      fractionalSortKey
      item
      item_fr
      isInternational
      editable
      costLineType
      costLineLabel
      costLineEditLabel
      language
      number
      shootNumber
      rate
      exchangeEnabled
      exchangeRate
      rateInEuros
      quantity
      total
      totalMargin
      payrollTaxEnabled
      payrollTaxType
      overtimeHours1
      overtimeHours2
      overtimeHours3
      overtimeHours4
      otNumberOfHours
      overtimeHoursCost
      isCustomCostLine
      referenceCostLineUuid
      provisionalQuantity
      provisionalNumber
      provisionalShootNumber
      provisionalRate
      provisionalOtTotal
      provisionalTotal
      provisionalPayrollTaxEnabled
      provisionalPayrollTaxType
      actualTotal
      actualPayrollTaxEnabled
      actualPayrollTaxType
      purchaseTotal
      supplierStatus
      supplierId
      paymentStatus
      purchaseId
      comments
      invoiceId
      invoiceAvailable
      invoiceDocuments {
        bucket
        region
        key
        identityId
      }
      poAvailable
      purchaseOrderId
      rowColor
      costlineHeader
      startDate
      endDate
      days
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.RecapQuoteInfoByTenantIdWithSortDaysQueryVariables,
		APITypes.RecapQuoteInfoByTenantIdWithSortDaysQuery
	>
export const getSectionRename =
	/* GraphQL */ `query GetSectionRename($id: ID!) {
  getSectionRename(id: $id) {
    id
    quoteId
    tenantId
    sectionId
    sectionType
    sectionName
    sectionName_fr
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
		APITypes.GetSectionRenameQueryVariables,
		APITypes.GetSectionRenameQuery
	>
export const listSectionRenames = /* GraphQL */ `query ListSectionRenames(
  $filter: ModelSectionRenameFilterInput
  $limit: Int
  $nextToken: String
) {
  listSectionRenames(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      quoteId
      tenantId
      sectionId
      sectionType
      sectionName
      sectionName_fr
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListSectionRenamesQueryVariables,
	APITypes.ListSectionRenamesQuery
>
export const sectionRenameByQuoteId =
	/* GraphQL */ `query SectionRenameByQuoteId(
  $quoteId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSectionRenameFilterInput
  $limit: Int
  $nextToken: String
) {
  sectionRenameByQuoteId(
    quoteId: $quoteId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      sectionId
      sectionType
      sectionName
      sectionName_fr
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.SectionRenameByQuoteIdQueryVariables,
		APITypes.SectionRenameByQuoteIdQuery
	>
export const sectionRenameByTenantId =
	/* GraphQL */ `query SectionRenameByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSectionRenameFilterInput
  $limit: Int
  $nextToken: String
) {
  sectionRenameByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      quoteId
      tenantId
      sectionId
      sectionType
      sectionName
      sectionName_fr
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.SectionRenameByTenantIdQueryVariables,
		APITypes.SectionRenameByTenantIdQuery
	>
export const getSubscriptionDetails =
	/* GraphQL */ `query GetSubscriptionDetails($id: ID!) {
  getSubscriptionDetails(id: $id) {
    id
    tenantId
    stripeId
    subscriptionEndDate
    subscriptionStatus
    isEnterpriseUser
    subscriptionSubId
    subscriptionPriceId
    subscriptionProductId
    stripePaymentMethodId
    actualPaidTeamCount
    totalTeamCount
    activeFlag
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
		APITypes.GetSubscriptionDetailsQueryVariables,
		APITypes.GetSubscriptionDetailsQuery
	>
export const listSubscriptionDetails =
	/* GraphQL */ `query ListSubscriptionDetails(
  $filter: ModelSubscriptionDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubscriptionDetails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      stripeId
      subscriptionEndDate
      subscriptionStatus
      isEnterpriseUser
      subscriptionSubId
      subscriptionPriceId
      subscriptionProductId
      stripePaymentMethodId
      actualPaidTeamCount
      totalTeamCount
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ListSubscriptionDetailsQueryVariables,
		APITypes.ListSubscriptionDetailsQuery
	>
export const subscriptionDetailsByTenantId =
	/* GraphQL */ `query SubscriptionDetailsByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSubscriptionDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  subscriptionDetailsByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      stripeId
      subscriptionEndDate
      subscriptionStatus
      isEnterpriseUser
      subscriptionSubId
      subscriptionPriceId
      subscriptionProductId
      stripePaymentMethodId
      actualPaidTeamCount
      totalTeamCount
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.SubscriptionDetailsByTenantIdQueryVariables,
		APITypes.SubscriptionDetailsByTenantIdQuery
	>
export const subscriptionDetailsByStripeId =
	/* GraphQL */ `query SubscriptionDetailsByStripeId(
  $stripeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSubscriptionDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  subscriptionDetailsByStripeId(
    stripeId: $stripeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      stripeId
      subscriptionEndDate
      subscriptionStatus
      isEnterpriseUser
      subscriptionSubId
      subscriptionPriceId
      subscriptionProductId
      stripePaymentMethodId
      actualPaidTeamCount
      totalTeamCount
      activeFlag
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.SubscriptionDetailsByStripeIdQueryVariables,
		APITypes.SubscriptionDetailsByStripeIdQuery
	>
export const getSuppliers = /* GraphQL */ `query GetSuppliers($id: ID!) {
  getSuppliers(id: $id) {
    id
    tenantId
    activeFlag
    name
    idnumber
    vatNumber
    website
    phone
    firstName
    lastName
    contactEmail
    companyEmail
    contactPhone
    line01
    line02
    city
    state
    postalCode
    country
    currency
    paymentTerms
    taxType
    taxRate
    thirdPartyAccounts
    note
    bank
    iban
    bic
    accountName
    commercialName
    supplierCreditorAccount
    supplierSubAccount
    supplierType
    individualType
    isArchived
    internalADR
    quoteSectionDetails {
      quoteType
      categoryUuid
      subCategoryUuid
      categoryName
      subCategoryName
      categoryName_fr
      subCategoryName_fr
    }
    purchase {
      items {
        id
        tenantId
        activeFlag
        quoteId
        supplierId
        recapCostlineId
        quoteName
        projectName
        supplierName
        recapCostlineItem
        recapCostlineItem_fr
        currency
        provisionalTotal
        invoiceTotal
        taxAmount
        purchaseInvoiceDueDate
        purchaseArchivedDate
        purchasePaidDate
        supplierCreditorAccount
        purchaseOrderId
        poAvailable
        invoiceAvailable
        paymentStatus
        purchaseType
        supplierType
        invoiceKey
        tags
        invoiceDocuments {
          bucket
          region
          key
          identityId
        }
        quoteNumber
        projectNumber
        invoiceNumber
        purchaseToPayDate
        purchaseNumber
        purchaseOrderNumber
        projectId
        supplierTerms
        quantity
        number
        rate
        taxRate
        deliveryDate
        deliveryAddress
        poComments
        poGenerated
        createdOn
        updatedOn
        _deleted
        _version
        _lastChangedAt
      }
      nextToken
    }
    _deleted
    _version
    _lastChangedAt
    createdOn
    updatedOn
  }
}
` as GeneratedQuery<
	APITypes.GetSuppliersQueryVariables,
	APITypes.GetSuppliersQuery
>
export const listSuppliers = /* GraphQL */ `query ListSuppliers(
  $filter: ModelSuppliersFilterInput
  $limit: Int
  $nextToken: String
) {
  listSuppliers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      contactEmail
      companyEmail
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      thirdPartyAccounts
      note
      bank
      iban
      bic
      accountName
      commercialName
      supplierCreditorAccount
      supplierSubAccount
      supplierType
      individualType
      isArchived
      internalADR
      quoteSectionDetails {
        quoteType
        categoryUuid
        subCategoryUuid
        categoryName
        subCategoryName
        categoryName_fr
        subCategoryName_fr
      }
      purchase {
        items {
          id
          tenantId
          activeFlag
          quoteId
          supplierId
          recapCostlineId
          quoteName
          projectName
          supplierName
          recapCostlineItem
          recapCostlineItem_fr
          currency
          provisionalTotal
          invoiceTotal
          taxAmount
          purchaseInvoiceDueDate
          purchaseArchivedDate
          purchasePaidDate
          supplierCreditorAccount
          purchaseOrderId
          poAvailable
          invoiceAvailable
          paymentStatus
          purchaseType
          supplierType
          invoiceKey
          tags
          quoteNumber
          projectNumber
          invoiceNumber
          purchaseToPayDate
          purchaseNumber
          purchaseOrderNumber
          projectId
          supplierTerms
          quantity
          number
          rate
          taxRate
          deliveryDate
          deliveryAddress
          poComments
          poGenerated
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListSuppliersQueryVariables,
	APITypes.ListSuppliersQuery
>
export const suppliersByTenantId = /* GraphQL */ `query SuppliersByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSuppliersFilterInput
  $limit: Int
  $nextToken: String
) {
  suppliersByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      tenantId
      activeFlag
      name
      idnumber
      vatNumber
      website
      phone
      firstName
      lastName
      contactEmail
      companyEmail
      contactPhone
      line01
      line02
      city
      state
      postalCode
      country
      currency
      paymentTerms
      taxType
      taxRate
      thirdPartyAccounts
      note
      bank
      iban
      bic
      accountName
      commercialName
      supplierCreditorAccount
      supplierSubAccount
      supplierType
      individualType
      isArchived
      internalADR
      quoteSectionDetails {
        quoteType
        categoryUuid
        subCategoryUuid
        categoryName
        subCategoryName
        categoryName_fr
        subCategoryName_fr
      }
      purchase {
        items {
          id
          tenantId
          activeFlag
          quoteId
          supplierId
          recapCostlineId
          quoteName
          projectName
          supplierName
          recapCostlineItem
          recapCostlineItem_fr
          currency
          provisionalTotal
          invoiceTotal
          taxAmount
          purchaseInvoiceDueDate
          purchaseArchivedDate
          purchasePaidDate
          supplierCreditorAccount
          purchaseOrderId
          poAvailable
          invoiceAvailable
          paymentStatus
          purchaseType
          supplierType
          invoiceKey
          tags
          quoteNumber
          projectNumber
          invoiceNumber
          purchaseToPayDate
          purchaseNumber
          purchaseOrderNumber
          projectId
          supplierTerms
          quantity
          number
          rate
          taxRate
          deliveryDate
          deliveryAddress
          poComments
          poGenerated
          createdOn
          updatedOn
          _deleted
          _version
          _lastChangedAt
        }
        nextToken
      }
      _deleted
      _version
      _lastChangedAt
      createdOn
      updatedOn
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.SuppliersByTenantIdQueryVariables,
	APITypes.SuppliersByTenantIdQuery
>
export const getUserInfo = /* GraphQL */ `query GetUserInfo($id: ID!) {
  getUserInfo(id: $id) {
    id
    email
    activeFlag
    firstName
    lastName
    phone
    tenantId
    companyTenantId
    currentCompanyTenantId
    currentCompanyName
    cognitoGroup
    teamIds
    subTeamIds
    projectIds
    userLanguage
    hideTour
    _deleted
    _version
    _lastChangedAt
    createdAt
    updatedAt
    owner
  }
}
` as GeneratedQuery<
	APITypes.GetUserInfoQueryVariables,
	APITypes.GetUserInfoQuery
>
export const listUserInfos = /* GraphQL */ `query ListUserInfos(
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      activeFlag
      firstName
      lastName
      phone
      tenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      cognitoGroup
      teamIds
      subTeamIds
      projectIds
      userLanguage
      hideTour
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.ListUserInfosQueryVariables,
	APITypes.ListUserInfosQuery
>
export const userInfoByEmail = /* GraphQL */ `query UserInfoByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  userInfoByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      activeFlag
      firstName
      lastName
      phone
      tenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      cognitoGroup
      teamIds
      subTeamIds
      projectIds
      userLanguage
      hideTour
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.UserInfoByEmailQueryVariables,
	APITypes.UserInfoByEmailQuery
>
export const userInfoByTenantId = /* GraphQL */ `query UserInfoByTenantId(
  $tenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  userInfoByTenantId(
    tenantId: $tenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      activeFlag
      firstName
      lastName
      phone
      tenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      cognitoGroup
      teamIds
      subTeamIds
      projectIds
      userLanguage
      hideTour
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
` as GeneratedQuery<
	APITypes.UserInfoByTenantIdQueryVariables,
	APITypes.UserInfoByTenantIdQuery
>
export const userInfoByCurrentTenantId =
	/* GraphQL */ `query UserInfoByCurrentTenantId(
  $currentCompanyTenantId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  userInfoByCurrentTenantId(
    currentCompanyTenantId: $currentCompanyTenantId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      activeFlag
      firstName
      lastName
      phone
      tenantId
      companyTenantId
      currentCompanyTenantId
      currentCompanyName
      cognitoGroup
      teamIds
      subTeamIds
      projectIds
      userLanguage
      hideTour
      _deleted
      _version
      _lastChangedAt
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.UserInfoByCurrentTenantIdQueryVariables,
		APITypes.UserInfoByCurrentTenantIdQuery
	>
export const reportingLogs =
	/* GraphQL */ `query ReportingLogs($input: ReportingLogsInput!) {
  reportingLogs(input: $input) {
    items {
      id
      occurredAt
      category
      actionLabel
      actorLabel
      projectLabel
      freelancerLabel
      source
      rawAction
    }
    nextToken
  }
}
` as GeneratedQuery<
		APITypes.ReportingLogsQueryVariables,
		APITypes.ReportingLogsQuery
	>
export const getQuoteTotals =
	/* GraphQL */ `query GetQuoteTotals($quoteId: String!) {
  getQuoteTotals(quoteId: $quoteId) {
    id
    name
    sectionTotals {
      isInternational
      sectionPrefix
      sectionRoman
      sectionId
      sectionUuid
      sectionName
      sectionName_fr
      budgetTotal
      provisionalTotal
      actualTotal
      purchaseTotal
      budgetWithMarginTotal
      attribute
    }
    localSectionTotals {
      isInternational
      sectionPrefix
      sectionRoman
      sectionId
      sectionUuid
      sectionName
      sectionName_fr
      budgetTotal
      provisionalTotal
      actualTotal
      purchaseTotal
      budgetWithMarginTotal
      attribute
    }
    internationalSectionTotals {
      isInternational
      sectionPrefix
      sectionRoman
      sectionId
      sectionUuid
      sectionName
      sectionName_fr
      budgetTotal
      provisionalTotal
      actualTotal
      purchaseTotal
      budgetWithMarginTotal
      attribute
    }
    totals {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    localTotals {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    internationalTotals {
      budgetSubTotal
      budgetGrandTotal
      budgetMargin
      budgetMarginPercentage
      budgetSeperateMargin
      budgetSeperateMarginPercentage
      budgetSeperateOverhead
      budgetSeperateOverheadPercentage
      provisionalSubTotal
      provisionalGrandTotal
      provisionalMargin
      provisionalMarginPercentage
      actualSubTotal
      actualGrandTotal
      actualMargin
      actualMarginPercentage
      purchaseSubTotal
      purchaseGrandTotal
      purchaseMargin
      purchaseMarginPercentage
      grandBudgetWithMarginTotal
      noMarginTotalPercentage
      subTotalBudgetWithMargin
      subTotalBudgetWithoutMargin
      subTotalBudgetWithMarginPercentage
    }
    discount {
      totalAfterDiscount
      totalDiscount
      budgetTotalDiscountOnMargin
      budgetTotalDiscountOnMarginPercentage
      budgetTotalDiscountPercentage
      provisionalTotalDiscountOnMargin
      provisionalTotalDiscountOnMarginPercentage
      provisionalTotalDiscountPercentage
      actualTotalDiscountOnMargin
      actualTotalDiscountOnMarginPercentage
      actualTotalDiscountPercentage
      purchaseTotalDiscountOnMargin
      purchaseTotalDiscountOnMarginPercentage
      purchaseTotalDiscountPercentage
    }
  }
}
` as GeneratedQuery<
		APITypes.GetQuoteTotalsQueryVariables,
		APITypes.GetQuoteTotalsQuery
	>
